export type UiLanguage = 'en' | 'nl';

const en = {
  'nav.discover': 'Discover',
  'nav.dashboard': 'Home',
  'nav.library': 'My library',
  'nav.koboSync': 'Kobo Sync',
  'nav.catalog': 'Catalog',
  'nav.trending': 'Trending',
  'nav.following': 'Following',
  'nav.reader': 'Kobo',
  'nav.manage': 'Manage',
  'nav.downloads': 'Downloads',
  'nav.releaseProfiles': 'Release profiles',
  'nav.requestProcesses': 'Requests',
  'nav.users': 'Users',
  'nav.operations': 'Operations',
  'nav.add': 'Add book',
  'nav.settings': 'Settings',
  'nav.close': 'Close navigation',
  'nav.open': 'Open navigation',
  'header.search': 'Search books, authors or ISBN',
  'header.searchLabel': 'Search the catalog',
  'search.loading': 'Searching local books…',
  'search.error': 'Local search could not be loaded.',
  'search.empty': 'No local books found.',
  'search.external': 'Search externally for “{query}”',
  'search.inLibrary': 'My library',
  'search.catalog': 'Catalog',
  'search.trending': 'Trending',
  'search.metadata': 'Metadata',
  'header.activity': 'Activity',
  'header.userMenu': 'User menu',
  'header.language': 'Language',
  'header.mySettings': 'My settings',
  'header.adminSettings': 'Admin settings',
  'header.reportBug': 'Report a bug',
  'issueReport.title': 'Report a problem',
  'issueReport.intro':
    'Tell us what went wrong. Your report is sent privately to the BookFlow team.',
  'issueReport.close': 'Close problem report',
  'issueReport.subject': 'Subject',
  'issueReport.pageUrl': 'Page URL',
  'issueReport.description': 'Description',
  'issueReport.characterCount': '{count} of {max} characters',
  'issueReport.chooseImage': 'Choose image',
  'issueReport.imageHint':
    'Optional: PNG, JPEG or WebP up to 5 MB. You can also drag or paste an image.',
  'issueReport.imagePreview': 'Selected image preview',
  'issueReport.removeImage': 'Remove image',
  'issueReport.imageTypeError': 'Choose a PNG, JPEG or WebP image.',
  'issueReport.imageSizeError': 'The image must be no larger than 5 MB.',
  'issueReport.requiredError': 'Enter a subject and description.',
  'issueReport.submit': 'Submit problem',
  'issueReport.submitting': 'Submitting…',
  'issueReport.success': 'Problem submitted (#{number})',
  'issueReport.successAttachmentFailed':
    'Problem submitted (#{number}), but the attachment could not be added.',
  'issueReport.submitFailed': 'The problem could not be submitted. Try again.',
  'header.signOut': 'Sign out',
  'header.myself': 'Myself',
  'header.downloadAs': 'Download as',
  'header.downloadingAs': 'Downloading as {user}',
  'header.loadingUsers': 'Loading users…',
  'header.restart': 'Restart',
  'header.debugGathering': 'Gathering debug logs… This may take a minute.',
  'header.debugSuccess': 'Debug logs downloaded successfully.',
  'header.debugFailed': 'Debug download failed. Check the console for details.',
  'header.debugFailedDetail': 'Debug download failed: {error}',
  'nav.primary': 'Primary navigation',
  'activity.title': 'Activity',
  'activity.all': 'All',
  'activity.downloads': 'Downloads',
  'activity.requests': 'Requests',
  'activity.history': 'History',
  'activity.complete': 'Complete',
  'activity.failed': 'Failed',
  'activity.inProgress': 'In progress',
  'activity.needsReview': 'Needs review',
  'activity.waiting': 'Waiting',
  'activity.noActivity': 'No activity',
  'activity.noRequests': 'No requests',
  'activity.noDownloads': 'No downloads',
  'activity.noHistory': 'No history',
  'activity.loadingRequests': 'Loading requests…',
  'activity.loadingHistory': 'Loading history…',
  'activity.clearCompleted': 'Clear completed',
  'activity.clearHistory': 'Clear history',
  'activity.pin': 'Pin activity sidebar',
  'activity.unpin': 'Unpin activity sidebar',
  'activity.filterByUser': 'Filter by user',
  'activity.filteredByUser': 'Filtered by user {user}',
  'activity.allUsers': 'All users',
  'activity.backToActivity': 'Back to activity',
  'activity.openHistory': 'Open history',
  'activity.close': 'Close activity sidebar',
  'activity.loadMore': 'Load more',
  'interactiveSearch.title': 'Interactive Search',
  'interactiveSearch.freshSearch':
    'A fresh manual search shows every result, including releases the active profile would skip.',
  'interactiveSearch.searching': 'Searching all configured sources…',
  'interactiveSearch.results': '{count} results',
  'interactiveSearch.searchAgain': 'Search again',
  'interactiveSearch.refresh': 'Refresh',
  'interactiveSearch.sort': 'Sort results',
  'interactiveSearch.sortScore': 'Profile score',
  'interactiveSearch.sortPeers': 'Seeders / peers',
  'interactiveSearch.sortSize': 'Size',
  'interactiveSearch.sortTitle': 'Title',
  'interactiveSearch.noResults': 'No results yet. Refresh after configured sources have responded.',
  'interactiveSearch.release': 'Release',
  'interactiveSearch.source': 'Source / indexer',
  'interactiveSearch.protocol': 'Protocol',
  'interactiveSearch.size': 'Size',
  'interactiveSearch.peers': 'Peers',
  'interactiveSearch.languageFormat': 'Language / format',
  'interactiveSearch.score': 'Score',
  'interactiveSearch.decision': 'Profile decision',
  'interactiveSearch.action': 'Action',
  'interactiveSearch.eligible': 'Eligible',
  'interactiveSearch.grab': 'Grab',
  'interactiveSearch.grabOverride': 'Grab with override',
  'interactiveSearch.showAttempts': 'Show download attempts ({count})',
  'interactiveSearch.hideAttempts': 'Hide download attempts ({count})',
  'interactiveSearch.noAttempts': 'No download attempts yet.',
  'interactiveSearch.close': 'Close interactive search',
  'interactiveSearch.noCover': 'No cover',
  'interactiveSearch.profile': 'Profile',
  'interactiveSearch.defaultProfile': 'Default',
  'interactiveSearch.starting': 'Starting',
  'interactiveSearch.sources': 'Result sources',
  'interactiveSearch.allSources': 'All',
  'interactiveSearch.filterFormat': 'Filter by format',
  'interactiveSearch.allFormats': 'All formats',
  'interactiveSearch.filterLanguage': 'Filter by language',
  'interactiveSearch.allLanguages': 'All languages',
  'interactiveSearch.blocked': 'Blocked',
  'interactiveSearch.rejected': 'Rejected by profile',
  'interactiveSearch.selected': 'Selected',
  'interactiveSearch.retry': 'Retry',
  'interactiveSearch.retrySuccess': 'Download retry scheduled',
  'interactiveSearch.forceConfirm':
    'This release was rejected by the active profile or blocklist. Force the grab anyway?',
  'interactiveSearch.auditReason': 'Required audit reason for this override',
  'interactiveSearch.forceSuccess': 'Release force-grabbed and audit recorded',
  'interactiveSearch.grabSuccess': 'Release queued for download',
  'interactiveSearch.failed': 'Search failed.',
  'interactiveSearch.timeout':
    'The search is taking longer than expected. Refresh to keep checking this run.',
  'interactiveSearch.unknownSource': 'Unknown source',
  'interactiveSearch.status.queued': 'Queued',
  'interactiveSearch.status.running': 'Searching',
  'interactiveSearch.status.completed': 'Completed',
  'interactiveSearch.status.partial': 'Partially completed',
  'interactiveSearch.status.failed': 'Failed',
  'interactiveSearch.attempt.queued': 'Queued',
  'interactiveSearch.attempt.submitted': 'Submitted to download client',
  'interactiveSearch.attempt.downloading': 'Downloading',
  'interactiveSearch.attempt.importing': 'Importing',
  'interactiveSearch.attempt.completed': 'Completed',
  'interactiveSearch.attempt.retryScheduled': 'Retry scheduled',
  'interactiveSearch.attempt.failed': 'Failed',
  'interactiveSearch.attempt.cancelled': 'Cancelled',
  'common.loading': 'Loading…',
  'common.retry': 'Try again',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save changes',
  'common.saving': 'Saving…',
  'common.delete': 'Delete',
  'common.unknownAuthor': 'Unknown author',
  'common.unknown': 'Unknown',
  'webReader.close': 'Close reader',
  'webReader.download': 'Download',
  'webReader.downloading': 'Downloading…',
  'webReader.contents': 'Contents',
  'webReader.display': 'Display',
  'webReader.fullscreen': 'Fullscreen',
  'webReader.moreActions': 'More reader actions',
  'webReader.readerActions': 'Reader actions',
  'webReader.readingProgress': 'Reading progress',
  'webReader.actionFailed': 'The action failed.',
  'common.results': '{count} results',
  'common.coverOf': 'Cover of {title}',
  'common.request': 'Request',
  'common.requestProcess': 'Request',
  'common.loadFailed': 'Could not load this page.',
  'pwa.updateAvailable': 'A BookFlow update is available.',
  'pwa.installPrompt': 'Install BookFlow for quick access.',
  'pwa.refresh': 'Refresh',
  'pwa.install': 'Install',
  'pwa.later': 'Later',
  'offline.eyebrow': 'Offline reading',
  'offline.title': 'Available without a connection',
  'offline.status': 'Offline',
  'offline.intro':
    'These books are stored completely on this device. Your reading progress will sync when BookFlow is online again.',
  'offline.loading': 'Loading offline booksâ€¦',
  'offline.emptyTitle': 'No books are available offline yet',
  'offline.emptyHelp':
    'Reconnect to BookFlow and wait until a book in Continue reading shows the Offline badge.',
  'offline.partialFailure':
    '{count} book(s) could not be refreshed. Previously stored books remain available.',
  'offline.cacheFailure': 'Offline storage could not be read or refreshed.',
  'offline.onlineCacheFailure': '{count} book(s) could not be made available offline.',
  'offline.retry': 'Try again',
  'offline.availableBadge': 'Offline Â· {progress}%',
  'offline.progress': '{progress}% read',
  'offline.open': 'Continue reading',
  'dashboard.eyebrow': 'Your BookFlow',
  'dashboard.title': 'Good to see you',
  'dashboard.subtitle': 'Pick up where you left off or discover something new.',
  'dashboard.continue': 'Continue reading',
  'dashboard.continueEmpty': 'No active book yet.',
  'dashboard.recent': 'Recently added',
  'dashboard.recentEmpty': 'No recent additions yet.',
  'dashboard.viewLibrary': 'View library',
  'dashboard.viewCatalog': 'Explore catalog',
  'dashboard.bookFallback': 'Book',
  'dashboard.trending': 'Trending this week',
  'dashboard.trendingSubtitle': 'Popular books from the current Dutch Bestseller 60.',
  'dashboard.viewTrending': 'View all',
  'dashboard.trendingEmpty': 'The weekly bestseller lists are not available yet.',
  'dashboard.trendingWeek': 'Week {week}, {year}',
  'dashboard.trendingShelf': 'Trending · Bestseller 60',
  'dashboard.recentRequests': 'Recent requests',
  'dashboard.requestsEmpty': 'You have not requested any books yet.',
  'dashboard.newBadge': 'New',
  'dashboard.requestBook': 'Book',
  'dashboard.requestStatus.available': 'Available',
  'dashboard.requestStatus.processing': 'Processing',
  'dashboard.requestStatus.rejected': 'Rejected',
  'dashboard.requestStatus.cancelled': 'Cancelled',
  'dashboard.requestStatus.failed': 'Failed',
  'dashboard.requestStatus.unknown': 'Unknown',
  'dashboard.scrollBack': 'scroll back',
  'dashboard.scrollForward': 'scroll forward',
  'dashboard.recentLoadFailed': 'Recently added books could not be loaded.',
  'dashboard.requestsLoadFailed': 'Recent requests could not be loaded.',
  'dashboard.readingLoadFailed': 'Reading progress could not be loaded.',
  'dashboard.trendingLoadFailed': 'Trending books could not be loaded.',
  'suggestions.eyebrow': 'Trending',
  'suggestions.title': 'Book suggestions',
  'suggestions.back': 'Back to home',
  'suggestions.loading': 'Loading suggestions…',
  'suggestions.invalid': 'This suggestion list does not exist.',
  'suggestions.loadFailed': 'Suggestions could not be loaded.',
  'suggestions.empty': 'No book suggestions are available yet.',
  'suggestions.loadMore': 'Load more suggestions',
  'suggestions.loadingMore': 'Loading more suggestions…',
  'suggestions.list.overall': 'Bestseller 60',
  'suggestions.list.fiction': 'Fiction',
  'suggestions.list.non_fiction': 'Non-fiction',
  'suggestions.list.thriller': 'Thrillers',
  'suggestions.list.youth': 'Children & young adult',
  'suggestions.list.cooking': 'Cooking',
  'library.eyebrow': 'My library',
  'library.title': 'Your books',
  'library.koboTitle': 'Kobo Sync',
  'library.summary': '{count} saved {works}',
  'library.work': 'book',
  'library.works': 'books',
  'library.waiting': ', {count} waiting to be found.',
  'library.search': 'Search title or author',
  'library.fileState': 'File availability',
  'library.all': 'All',
  'library.hasFiles': 'Available',
  'library.needsFiles': 'Needs files',
  'library.format': 'Format',
  'library.allFormats': 'All formats',
  'library.sort': 'Sort library',
  'library.sortRecent': 'Recently added',
  'library.sortTitle': 'Title',
  'library.sortAuthor': 'Author',
  'library.sortYear': 'Publication year',
  'library.grid': 'Grid',
  'library.list': 'List',
  'library.pageResults': 'Showing {from}–{to} of {total}',
  'library.pagination': 'Library pagination',
  'library.previous': 'Previous',
  'library.next': 'Next',
  'library.empty': 'Your library is empty',
  'library.emptyHelp': 'Find a book in the catalog and add it to your library.',
  'library.noMatch': 'No books match this search and filter.',
  'library.noMatchHelp': 'Adjust the search or filters and try again.',
  'library.untitled': 'Untitled book',
  'catalog.eyebrow': 'Discover',
  'catalog.title': 'Browse all books',
  'bulkLibrary.select': 'Select books',
  'bulkLibrary.cancelSelection': 'Stop selecting',
  'bulkLibrary.actions': 'Bulk library actions',
  'bulkLibrary.selected': '{count} selected',
  'bulkLibrary.selectPage': 'Select this page',
  'bulkLibrary.clear': 'Clear',
  'bulkLibrary.addSelected': 'Add {count} to library',
  'bulkLibrary.retrySelected': 'Retry {count} failed',
  'bulkLibrary.adding': 'Adding…',
  'bulkLibrary.inLibrary': 'In library',
  'bulkLibrary.selectBook': 'Select {title}',
  'bulkLibrary.deselectBook': 'Deselect {title}',
  'bulkLibrary.limit': 'You can select up to 100 books at a time.',
  'bulkLibrary.result': '{added} added, {existing} already in your library, {failed} failed.',
  'bulkLibrary.unavailableDetails': 'No imported ebook file: {ids}.',
  'bulkLibrary.notFoundDetails': 'No longer found: {ids}.',
  'catalog.subtitle': 'Explore the shared collection. Files and reading progress stay personal.',
  'catalog.search': 'Search title, author, series or ISBN',
  'catalog.allFormats': 'All formats',
  'catalog.formatLabel': 'Filter by format',
  'catalog.recent': 'Recently added',
  'catalog.titleSort': 'Title',
  'catalog.authorSort': 'Author',
  'catalog.yearSort': 'Publication year',
  'catalog.sortLabel': 'Sort catalog',
  'catalog.list': 'List',
  'catalog.grid': 'Grid',
  'catalog.loading': 'Loading catalog…',
  'catalog.empty': 'No books found.',
  'catalog.previous': 'Previous',
  'catalog.next': 'Next',
  'catalog.externalHelp': 'Only search outside your catalog when the book is not listed above.',
  'catalog.browseAuthors': 'Browse authors',
  'catalog.browseSeries': 'Browse series',
  'catalog.clearFilter': 'Clear catalog filter',
  'catalog.entityBooks': '{count} books',
  'catalog.entityEmpty': 'No {kind} found.',
  'catalog.entitySearch': 'Search {kind}',
  'catalog.books': 'Books',
  'catalogDetail.back': 'Back to catalog',
  'catalogDetail.backLibrary': 'Back to my library',
  'catalogDetail.backKobo': 'Back to Kobo Sync',
  'catalogDetail.backTrending': 'Back to Trending',
  'catalogDetail.shared': 'Shared catalog',
  'catalogDetail.openPersonal': 'Open personal book',
  'catalogDetail.readNow': 'Read now',
  'catalogDetail.downloading': 'Downloading…',
  'catalogDetail.requestBook': 'Request this book',
  'catalogDetail.requestCreated': 'Request created.',
  'catalogDetail.requestFailed': 'Request failed',
  'catalogDetail.addBook': 'Add to my library',
  'catalogDetail.adding': 'Adding…',
  'catalogDetail.added': 'Added to your library.',
  'catalogDetail.addFailed': 'Unable to add this book',
  'catalogDetail.addConfirmTitle': 'Add book to your library?',
  'catalogDetail.addConfirmDescription': 'Add “{title}” to your personal library.',
  'catalogDetail.checkingKobo': 'Checking your Kobo Sync settings…',
  'catalogDetail.addToKobo': 'Also add this book to Kobo Sync',
  'catalogDetail.addKoboNoFile': 'No compatible file is available for Kobo Sync.',
  'catalogDetail.addedKoboFailed':
    'The book was added to your library, but Kobo Sync failed: {error}',
  'catalogDetail.description': 'Description',
  'catalogDetail.noDescription': 'No description available.',
  'catalogDetail.statusAvailable': 'Available',
  'catalogDetail.statusInLibrary': 'In your library',
  'catalogDetail.statusRequested': 'Requested',
  'catalogDetail.statusNotAdded': 'Not in your library',
  'catalogDetail.published': 'Published',
  'catalogDetail.language': 'Language',
  'catalogDetail.pages': 'Pages',
  'catalogDetail.publisher': 'Publisher',
  'catalogDetail.formats': 'Formats',
  'catalogDetail.isbn': 'ISBN',
  'catalogDetail.seriesPart': 'Part {position}',
  'catalogDetail.personalTitle': 'Your book',
  'catalogDetail.personalHelp': 'Your personal availability and reading status.',
  'catalogDetail.readingProgress': 'Reading progress',
  'catalogDetail.continueReading': 'Continue reading',
  'catalogDetail.catalogAvailability': 'Catalog availability',
  'catalogDetail.available': 'Available',
  'catalogDetail.notAvailable': 'Not yet available',
  'catalogDetail.removeFromLibrary': 'Remove from my library',
  'catalogDetail.deleteCatalog': 'Delete from catalog',
  'catalogDetail.deleteCatalogConfirm': 'Permanently delete catalog',
  'catalogDetail.deleteCatalogTyped': 'Type the book title to confirm',
  'catalogDetail.cleanupPending': 'Catalog deleted; file cleanup is pending.',
  'catalogDetail.retryCleanup': 'Retry cleanup',
  'catalogDetail.removeLibraryConfirm':
    'This removes the book from your library and, when applicable, from Kobo Sync.',
  'catalogDetail.removedFromLibrary': 'Removed from your library.',
  'catalogDetail.removing': 'Removing…',
  'catalogDetail.confirm': 'Confirm',
  'catalogDetail.addedOn': 'Added to library',
  'catalogDetail.requestStatus': 'Request status',
  'catalogDetail.requestUpdated': 'Last updated',
  'catalogDetail.availableFiles': 'Available files',
  'catalogDetail.fileCount': '{count} files',
  'catalogDetail.noFormats': 'No files available yet',
  'catalogDetail.kobo': 'Kobo',
  'catalogDetail.koboActive': 'Synced',
  'catalogDetail.koboDeleted': 'Removed from Kobo',
  'catalogDetail.koboNotSynced': 'Not synced',
  'catalogDetail.request.pending_approval': 'Waiting for approval',
  'catalogDetail.request.approved': 'Approved',
  'catalogDetail.request.fulfilled': 'Available',
  'catalogDetail.request.rejected': 'Rejected',
  'catalogDetail.request.cancelled': 'Cancelled',
  'catalogDetail.reportTitle': 'Incorrect metadata?',
  'catalogDetail.reportHelp': 'Report a field for administrator review.',
  'catalogDetail.reportPlaceholder': 'What is incorrect?',
  'catalogDetail.report': 'Report',
  'catalogDetail.reportSent': 'Metadata report submitted.',
  'catalogDetail.reportFailed': 'Unable to submit report',
  'metadata.field.title': 'Title',
  'metadata.field.author': 'Author',
  'metadata.field.series': 'Series',
  'metadata.field.description': 'Description',
  'metadata.field.cover': 'Cover',
  'following.eyebrow': 'Following',
  'following.title': 'Authors and series',
  'following.subtitle': 'Let BookFlow find new titles and decide what happens next.',
  'following.placeholder': 'Author or series name',
  'following.searchProfile': 'Search profile',
  'following.searchProfileHelp': 'Name or phrase used by the selected metadata provider.',
  'following.type': 'Monitor type',
  'following.provider': 'Provider',
  'following.providerId': 'Provider identifier',
  'following.providerIdPlaceholder': 'Optional provider ID',
  'following.providerIdHelp': 'Use this when you know the provider-specific author or series ID.',
  'following.unknownProvider': 'Unknown provider',
  'following.scanSchedule': 'Scan schedule',
  'following.scanEveryHours': 'Every {hours} hours',
  'following.scanEveryMinutes': 'Every {minutes} minutes',
  'following.action': 'On discovery',
  'following.author': 'Author',
  'following.series': 'Series',
  'following.notify': 'Notify me',
  'following.request': 'Request',
  'following.acquire': 'Acquire automatically',
  'following.acquireRestricted': 'Automatic request processing requires download permission.',
  'following.add': 'Start following',
  'following.results': 'Results',
  'following.scan': 'Scan now',
  'following.resume': 'Resume',
  'following.pause': 'Pause',
  'following.nextScan': 'Next scan: {date}',
  'following.scanScheduled': 'Scan scheduled',
  'following.empty': 'You are not following any authors or series yet.',
  'following.noDiscoveries': 'No titles discovered yet.',
  'following.koboIntent': 'Add discovered books to Kobo when available',
  'following.koboOn': 'Kobo on',
  'following.koboOff': 'Kobo off',
  'following.state.discovered': 'Newly discovered',
  'following.state.present': 'Already available',
  'following.state.future': 'Upcoming',
  'following.state.requested': 'Requested',
  'following.state.ignored': 'Ignored',
  'following.ignoreDiscovery': 'Ignore',
  'following.restoreDiscovery': 'Restore',
  'following.discoveryUpdateFailed': 'The discovery could not be updated.',
  'reader.eyebrow': 'Personal',
  'reader.title': 'Kobo',
  'reader.subtitle': 'Connect your Kobo and manage browser notifications per device.',
  'reader.notificationsSubtitle': 'Manage browser notifications for this account and device.',
  'reader.patcherTitle': 'Windows Kobo Patcher',
  'reader.patcherHelp':
    'Download the Windows app and sign in with your BookFlow account. The wizard guides you through connecting, choosing and setting up your Kobo. For external login, you can also use a pairing code.',
  'reader.downloadPatcher': 'Download Windows Patcher',
  'reader.generateCode': 'Generate pairing code',
  'reader.oneTimeCode': 'One-time pairing code',
  'reader.copy': 'Copy',
  'reader.codeValidUntil': 'Valid until {expiresAt}. Do not share this code with anyone.',
  'reader.soon': 'soon',
  'reader.patcherNote':
    'The patcher can restore an original configuration backup, or restore only the official Kobo sync without a backup.',
  'reader.webPush': 'Web push',
  'reader.webPushHelp': 'Notifications for monitors, requests and available books.',
  'reader.enablePush': 'Enable notifications',
  'reader.browserDevice': 'Browser device',
  'reader.noDevices': 'No registered browser devices.',
  'reader.notificationTypes': 'Notification types',
  'reader.notificationTypesHelp': 'These choices apply to Web Push and Apprise.',
  'reader.sendTest': 'Send test notification',
  'reader.pairingCreated': 'Pairing code created. It is single-use and temporary.',
  'reader.pairingFailed': 'The pairing code could not be created.',
  'reader.pushUnsupported': 'This browser does not support web push.',
  'reader.pushDenied': 'Browser notifications are not allowed.',
  'reader.pushUnconfigured': 'Web push has not been configured by the administrator yet.',
  'reader.pushEnabled': 'Browser notifications are enabled.',
  'reader.pushFailed': 'Web push could not be enabled.',
  'reader.ruleSaveFailed': 'The notification rule could not be saved.',
  'reader.ruleSaved': 'Notification rule saved.',
  'reader.saveFilters': 'Save filters',
  'reader.testSent': 'Test notification sent to {count} device(s).',
  'reader.testFailed': 'The test notification could not be sent.',
  'reader.eventMonitor': 'New title from an author or series',
  'reader.eventRequest': 'Request status',
  'reader.eventAvailable': 'Book is available',
  'reader.eventRequestError': 'Download or processing failed',
  'reader.eventMetadata': 'Metadata report status',
  'reader.eventBackupError': 'Backup error',
  'reader.patcherUnavailable': 'Patcher unavailable',
  'reader.version': 'Protocol version {version}',
  'reader.manualConfiguration': 'Manual configuration',
  'reader.manualConfigurationHelp':
    'Open .kobo/Kobo/Kobo eReader.conf and set api_endpoint in [OneStoreServices] to your personal endpoint ending in {suffix}. Make a copy first; this changes Kobo Store/OverDrive behaviour.',
  'reader.filtersInvalid': 'Filters must be a JSON object.',
  'reader.filtersLabel': 'Filters for {event}',
  'koboPanel.title': 'Kobo sync',
  'koboPanel.subtitle': 'Manage Kobo sync and the readers connected to your account.',
  'koboPanel.loading': 'Loading Kobo settings…',
  'koboPanel.loadFailed': 'Kobo settings could not be loaded.',
  'koboPanel.enable': 'Enable Kobo sync',
  'koboPanel.enableHelp': 'Disable this to stop connected readers from receiving library updates.',
  'koboPanel.enabledToast': 'Kobo sync enabled.',
  'koboPanel.disabledToast': 'Kobo sync disabled.',
  'koboPanel.updateFailed': 'Kobo sync could not be updated.',
  'koboPanel.devices': 'Connected readers',
  'koboPanel.devicesHelp':
    'Use the Windows patcher and sign in with your BookFlow account to connect a reader.',
  'koboPanel.noDevices': 'No active Kobo readers are connected.',
  'koboPanel.unnamedDevice': 'Unnamed Kobo reader',
  'koboPanel.created': 'Created {date}',
  'koboPanel.lastUsed': 'Last used {date}',
  'koboPanel.never': 'never',
  'koboPanel.revoke': 'Revoke',
  'koboPanel.confirmRevoke': 'Confirm revoke',
  'koboPanel.revoking': 'Revoking…',
  'koboPanel.revokeConfirm':
    'Revoke this reader? It will no longer be able to synchronize until it is paired again.',
  'koboPanel.revokedToast': 'Kobo reader revoked.',
  'koboPanel.revokeFailed': 'The Kobo reader could not be revoked.',
  'settings.title': 'My settings',
  'settings.account': 'Account',
  'settings.username': 'Username',
  'settings.email': 'Account email',
  'settings.password': 'Password',
  'settings.envControlled': 'This setting is controlled by an environment variable',
  'settings.unavailable': 'Unavailable',
  'settings.restartHelp': 'Changing this setting requires a container restart',
  'settings.andMore': 'and {count} more…',
  'settings.userOverridden': 'Overridden by user',
  'settings.reset': 'Reset',
  'settings.moveUp': 'Move up',
  'settings.moveDown': 'Move down',
  'settings.removeRow': 'Remove row',
  'settings.unknownCustomComponent': 'Unknown settings component: {component}',
  'settings.unknownFieldType': 'Unknown field type',
  'settings.displayName': 'Display name',
  'settings.language': 'Interface language',
  'settings.languageHelp': 'BookFlow uses this language whenever you sign in.',
  'settings.notifications': 'Personal notifications',
  'settings.enableNotifications': 'Enable personal notifications',
  'settings.testDestination': 'Test saved destination',
  'settings.sendingTest': 'Sending test…',
  'settings.updated': 'Settings updated',
  'settings.theme': 'Theme',
  'settings.themeHelp': 'Choose how BookFlow looks on this device.',
  'settings.themeSystem': 'Use system setting',
  'settings.themeLight': 'Light',
  'settings.themeDark': 'Dark',
  'settings.loadFailed': 'Settings could not be loaded.',
  'settings.saveFailed': 'Settings could not be updated.',
  'settings.testFailed': 'The test notification could not be sent.',
  'header.languageSaveFailed': 'Could not save language preference',
  'language.en': 'English',
  'language.nl': 'Nederlands',
  'login.welcome': 'Welcome to BookFlow',
  'login.subtitle': 'Sign in to continue to your library.',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.remember': 'Remember me for 7 days',
  'login.signIn': 'Sign in',
  'login.signingIn': 'Signing in…',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.usePassword': 'Use password',
  'login.hide': 'Hide',
  'admin.defaultLanguage': 'Default interface language',
  'admin.defaultLanguageHelp':
    'Language assigned to newly created users. Existing users keep their personal preference.',
  'admin.operationsEyebrow': 'Manage',
  'admin.usersEyebrow': 'Manage',
  'admin.usersTitle': 'Users',
  'admin.usersSubtitle':
    'Manage accounts, login sessions, IP addresses, download history and Kobo sync activity.',
  'admin.viewAudit': 'Activity & audit',
  'admin.hideAudit': 'Hide activity',
  'admin.editUser': 'Edit',
  'admin.openUserProfile': 'Open profile for {username}',
  'admin.userProfileEyebrow': 'User profile',
  'admin.backToUsers': 'Back to users',
  'admin.userLoading': 'Loading user profile…',
  'admin.userLoadFailed': 'The user profile could not be loaded.',
  'admin.userNotFound': 'User not found.',
  'admin.allUsers': 'All users',
  'admin.userCount': '{count} users',
  'admin.searchUsers': 'Search',
  'admin.searchUsersPlaceholder': 'Search users…',
  'admin.userColumn': 'User',
  'admin.emailColumn': 'Email',
  'admin.authColumn': 'Authentication',
  'admin.roleColumn': 'Role',
  'admin.statusColumn': 'Status',
  'admin.createdColumn': 'Created',
  'admin.actionsColumn': 'Actions',
  'admin.activeStatus': 'Active',
  'admin.inactiveStatus': 'Inactive',
  'admin.noMatchingUsers': 'No matching users found.',
  'admin.loadingUsers': 'Loading users…',
  'admin.noUsers': 'No users yet.',
  'admin.noUsersHelp':
    'Create a local administrator account before enabling OIDC to avoid being locked out.',
  'admin.loadingUserDetails': 'Loading user details…',
  'admin.createLocalUser': 'Create local user',
  'admin.noEmail': 'No email address',
  'admin.inactiveAuthMode': 'Inactive for the current authentication mode',
  'admin.saveChanges': 'Save changes',
  'admin.savingChanges': 'Saving…',
  'admin.deletingUser': 'Deleting…',
  'admin.confirmDeleteUser': 'Confirm deletion',
  'admin.deleteUser': 'Delete user',
  'admin.roleAdmin': 'Administrator',
  'admin.roleUser': 'User',
  'admin.minimumFourCharacters': 'At least 4 characters',
  'admin.confirmPassword': 'Confirm password',
  'admin.firstAccountHelp': 'This first account will be created as an administrator.',
  'admin.oidcAdminRequired': 'An administrator account is required before OIDC can be enabled.',
  'admin.creatingUser': 'Creating…',
  'admin.libraryCapability': 'Library access',
  'admin.autoApproveRequests': 'Automatically approve own requests',
  'admin.autoApproveRequestsHelp': 'This does not grant administrator permissions.',
  'admin.requestOnly': 'Requests only',
  'admin.downloadCapable': 'Downloads and requests',
  'admin.activeAccount': 'Active account',
  'admin.newPassword': 'New password',
  'admin.keepPasswordHelp': 'Leave empty to keep the current password',
  'admin.confirmNewPassword': 'Confirm the new password',
  'admin.displayNameManaged': 'The display name is managed by the identity provider.',
  'admin.emailSyncedCwa': 'The email address is synchronized from Calibre-Web.',
  'admin.emailManaged': 'The email address is managed by the identity provider.',
  'admin.roleManagedByGroup': 'The role is managed by the {group} identity-provider group.',
  'admin.roleManagedByOidc': 'The role is managed through OIDC group authorization.',
  'admin.roleAdminsOnly': 'Only administrators can change this role.',
  'admin.roleManagedExternally': 'The role is managed by the external authentication source.',
  'admin.roleCannotChange': 'The role cannot be changed.',
  'admin.userPreferences': 'User preferences',
  'admin.openUserPreferences': 'Open user preferences',
  'admin.operationsTitle': 'Metadata and backups',
  'admin.reportsTitle': 'Metadata reports',
  'admin.reportsHelp': 'Review reported data before applying a revision.',
  'admin.openReports': '{count} open',
  'admin.bookNumber': 'Book #{number}',
  'admin.noReports': 'No open reports.',
  'admin.current': 'Current',
  'admin.manualValue': 'Manual value (or select a candidate above)',
  'admin.newValue': 'New {field} value',
  'admin.preview': 'Preview diff',
  'admin.apply': 'Apply',
  'admin.reject': 'Reject',
  'admin.history': 'History',
  'admin.backupsTitle': 'Backup centre',
  'admin.createBackup': 'Create backup now',
  'admin.download': 'Download',
  'admin.restore': 'Restore',
  'admin.confirmRestore': 'Confirm restore',
  'admin.verify': 'Verify',
  'admin.encrypted': 'encrypted',
  'admin.unencrypted': 'not encrypted',
  'admin.verified': 'verified',
  'admin.unverified': 'not verified yet',
  'admin.noExplanation': 'No explanation provided.',
  'admin.revision': 'Revision {number}',
  'admin.revert': 'Revert',
  'admin.historyLookupTitle': 'Revision history',
  'admin.historyLookupHelp':
    'Load the complete provenance and restore an earlier revision for any book.',
  'admin.historyBookId': 'Book ID',
  'admin.loadHistory': 'Load history',
  'admin.historyInvalidBookId': 'Enter a valid book ID.',
  'admin.historyLoadFailed': 'Could not load the revision history.',
  'admin.historyEmpty': 'No metadata revisions for this book.',
  'admin.actor': 'Actor',
  'admin.systemActor': 'System',
  'admin.source': 'Source',
  'admin.reason': 'Reason',
  'admin.appliedAt': 'Applied',
  'admin.before': 'Before',
  'admin.after': 'After',
  'admin.noFieldChanges': 'No field changes recorded.',
  'admin.revertFailed': 'Could not restore this revision.',
  'admin.revertReason': 'Restored revision {number} from the admin history.',
  'admin.backupHelp': 'Database and configuration only; ebook files are excluded.',
  'admin.noBackups': 'No backups yet.',
  'admin.backupFailed': 'Backup action failed.',
  'admin.previewFailed': 'Could not prepare the diff.',
  'admin.applyFailed': 'Could not apply the metadata revision.',
  'admin.restoreStaged': 'Restore staged for the next application start.',
  'admin.restoreFailed': 'Could not stage the restore.',
  'admin.currentCover': 'Current cover',
  'admin.providerCover': 'Cover from {source}',
  'progress.title': 'Reading progress',
  'progress.help': 'Only active books appear on your dashboard. 100% removes this book from it.',
  'progress.label': 'Reading progress percentage',
  'progress.saved': 'Reading progress saved',
  'progress.resetSaved': 'Reading progress reset',
  'progress.reset': 'Reset',
  'progress.save': 'Save',
  'metadataReport.title': 'Incorrect metadata?',
  'metadataReport.help': 'Report a field; an administrator reviews the change before applying it.',
  'metadataReport.placeholder': 'What is incorrect?',
  'metadataReport.sent': 'Metadata report submitted',
  'bookDetail.noCover': 'No cover',
  'bookDetail.inLibrary': 'In your library',
  'bookDetail.unknownTitle': 'Untitled book',
  'bookDetail.availableFiles': 'Available files',
  'bookDetail.sizeUnknown': 'Size unknown',
  'bookDetail.download': 'Download',
  'bookDetail.releaseDownloading': 'A release is downloading.',
  'bookDetail.noFiles': 'No files are available yet.',
  'bookDetail.persistedDelivery': 'Persisted delivery state',
  'bookDetail.requestStatus': 'Request: {status}',
  'bookDetail.requestProcessStatus': 'Request: {status}',
  'bookDetail.nextSearch': 'Next search: {date}',
  'bookDetail.koboStatus': 'Kobo: {status}',
  'bookDetail.koboNotAdded': 'not added',
  'bookDetail.removeFromKobo': 'Remove from Kobo',
  'bookDetail.addToKobo': 'Add to Kobo',
  'bookDetail.removedFromKobo': 'Removed from Kobo',
  'bookDetail.addedToKobo': 'Added to Kobo',
  'bookDetail.availability': 'Availability',
  'bookDetail.filesAvailable': 'Files are available for this book.',
  'bookDetail.about': 'About this book',
  'bookDetail.noDescription': "No description is available from this book's metadata provider.",
  'bookDetail.backToLibrary': 'Back to library',
  'bookDetail.retry': 'Retry',
  'bookDetail.filesHelp': 'The newest downloaded file for each format.',
  'bookDetail.findRelease': 'Find another release',
  'bookDetail.unknownSource': 'Unknown source',
  'bookDetail.advancedReleases': 'Advanced: show all releases',
  'bookDetail.unlinkRelease': 'Unlink release',
  'bookDetail.releaseFileCount': '{count} file(s) in this release',
  'bookDetail.grabbedAt': 'Grabbed {date}',
  'bookDetail.requestMissingFiles':
    'No files are available yet. Request this book and an administrator will find a release.',
  'bookDetail.requestBook': 'Request this book',
  'bookDetail.requestPending': 'Request pending approval',
  'bookDetail.requestProcessInProgress': 'Request in progress',
  'bookDetail.requestCancelled': 'Request cancelled',
  'bookDetail.bookAvailable': 'Book available',
  'bookDetail.requestDeclined': 'Request declined',
  'bookDetail.cancelRequest': 'Cancel request',
  'bookDetail.bookRequested': 'Book requested',
  'bookDetail.downloadStarted': 'Download started',
  'bookDetail.releaseUnlinked': 'Release unlinked',
  'requestProcesses.title': 'Requests',
  'requestProcesses.help': 'Persisted searches, candidates, attempts, monitoring and recovery.',
  'requestProcesses.loadFailed': 'Failed to load requests',
  'requestProcesses.maintenance': 'Maintenance status',
  'requestProcesses.database': 'Database {status}',
  'requestProcesses.healthy': 'healthy',
  'requestProcesses.needsAttention': 'needs attention',
  'requestProcesses.migrations': '{count} migrations',
  'requestProcesses.pendingJobs': '{count} pending jobs',
  'requestProcesses.ready': 'Ready',
  'requestProcesses.attention': 'Attention required',
  'requestProcesses.migrationHistory': 'Migration history',
  'requestProcesses.pendingRequests': 'Pending requests',
  'requestProcesses.requestNumber': 'Request #{number}',
  'requestProcesses.approve': 'Approve',
  'requestProcesses.reject': 'Reject',
  'requestProcesses.approvalFailed': 'Approval failed',
  'requestProcesses.rejectionFailed': 'Rejection failed',
  'requestProcesses.noPendingRequests': 'No requests awaiting approval.',
  'requestProcesses.bookNumber': 'Book #{number}',
  'requestProcesses.nextSearch': 'Next search: {date}',
  'requestProcesses.notScheduled': 'not scheduled',
  'requestProcesses.searchFailed': 'Search failed',
  'requestProcesses.searchNow': 'Search now',
  'requestProcesses.unmonitor': 'Unmonitor',
  'requestProcesses.monitor': 'Monitor',
  'requestProcesses.details': 'Details',
  'requestProcesses.candidates': 'Candidates',
  'requestProcesses.attempts': 'Attempts',
  'requestProcesses.unknown': 'unknown',
  'requestProcesses.score': 'score {score}',
  'requestProcesses.accepted': 'accepted',
  'requestProcesses.rejected': 'rejected',
  'requestProcesses.retries': 'retries {count}',
  'requestProcesses.none': 'No requests yet.',
  'requests.requestedBy': 'Requested by',
  'requests.requestedByCount': 'Requested by {count} requesters',
  'requests.unknownRequester': 'Unknown user',
  'requests.requesterList': 'Requesters',
  'requests.cancelProcess': 'Cancel process (all requesters)',
  'manualUpload.choose': 'Upload EPUB',
  'manualUpload.confirm': 'Import file',
  'manualUpload.uploading': 'Uploading…',
  'manualUpload.complete': 'EPUB imported and requests completed.',
  'manualUpload.failed': 'The EPUB could not be imported.',
  'bookAdd.title': 'Add a book',
  'bookAdd.close': 'Close add-book dialog',
  'bookAdd.search': 'Title or author',
  'bookAdd.searching': 'Searching…',
  'bookAdd.searchFailed': 'Unable to search for books',
  'bookAdd.openFailed': 'Unable to open this book',
  'bookAdd.opening': 'Opening…',
  'bookAdd.view': 'View details',
  'bookAdd.external': 'Find an external book',
  'common.back': 'Back',
  'common.selectOption': 'Select an option',
  'common.select': 'Select…',
  'common.actionFailed': 'Action failed',
  'common.running': 'Running…',
  'common.advanced': 'Advanced',
  'onBehalf.close': 'Close download confirmation',
  'onBehalf.title': 'Download as {name}?',
  'onBehalf.help': "This download will use {name}'s output preferences and destination settings.",
  'onBehalf.itemTitle': 'Title',
  'onBehalf.queuing': 'Queuing…',
  'onBehalf.confirm': 'Confirm',
  'config.close': 'Close settings setup dialog',
  'config.dialog': 'Settings setup information',
  'config.required': 'Config volume required',
  'config.newFeature': 'New feature: Settings page',
  'config.requiredHelp': 'To save settings, add a config volume to your Docker Compose file:',
  'config.featureHelp':
    'BookFlow now has a settings page! To enable it, add a config volume to your Docker Compose file:',
  'config.requiredNote':
    'Without this volume, settings changes will not persist across container restarts.',
  'config.featureNote':
    'This allows you to configure settings through the UI and persist them across container restarts.',
  'config.continue': 'Continue to settings',
  'config.gotIt': 'Got it',
  'release.close': 'Close release dialog',
  'release.noCover': 'No cover available',
  'release.manualSearch': 'Manual search query',
  'release.sort': 'Sort releases',
  'release.filter': 'Filter releases',
  'release.format': 'Format',
  'release.language': 'Language',
  'release.indexers': 'Indexers',
  'release.allFormats': 'All formats',
  'release.allIndexers': 'All indexers',
  'release.customQuery': 'Type a custom search query (overrides all sources)',
  'release.bestMatch': 'Best match (default)',
  'release.noCoverText': 'No cover',
  'release.errorLoading': 'Error loading releases',
  'release.failed': 'Failed',
  'release.removeSelected': 'Remove selected {label}',
  'release.retry': 'Retry',
  'release.downloaded': 'Downloaded',
  'release.downloading': 'Downloading',
  'release.locating': 'Locating files',
  'release.resolving': 'Resolving',
  'release.queued': 'Queued',
  'release.download': 'Download',
  'release.onDisk': 'On disk',
  'release.findReleases': 'Find releases',
  'release.manualQuery': 'Manual query',
  'release.untitled': 'Untitled',
  'release.bookCover': 'Book cover',
  'release.readerCount': '{count} readers',
  'release.pageCount': '{count} pages',
  'release.seriesPosition': '#{position} in {series}',
  'release.seriesPositionOf': '#{position} of {count} in {series}',
  'release.partOfSeries': 'Part of {series}',
  'release.viewSeries': 'View series',
  'release.showLess': 'Show less',
  'release.more': 'more',
  'release.viewOn': 'View on {provider}',
  'release.apply': 'Apply',
  'release.manualQueryHelp': 'A manual query overrides ISBN, title, author and language expansion.',
  'activity.noCover': 'No cover',
  'activity.unknownTitle': 'Unknown title',
  'activity.rejectRequest': 'Reject request for {title}',
  'activity.optionalNote': 'Optional note shown to the user',
  'activity.rejecting': 'Rejecting…',
  'activity.reject': 'Reject',
  'activity.removeFromQueue': 'Remove from queue',
  'activity.stopDownload': 'Stop download',
  'activity.clear': 'Clear',
  'activity.approve': 'Approve',
  'activity.cancelRequest': 'Cancel request',
  'activity.action': 'Action',
  'activity.anySource': 'Any source',
  'activity.requested': 'Requested',
  'activity.type': 'Type',
  'activity.source': 'Source',
  'activity.attachedFile': 'Attached file',
  'activity.fieldTitle': 'Title',
  'activity.size': 'Size',
  'activity.format': 'Format',
  'activity.working': 'Working…',
  'activity.manuallyApprove': 'Manually mark as approved',
  'activity.browseAlternatives': 'Browse alternatives',
  'activity.unknown': 'Unknown',
  'activity.approveAttachedFile': 'Approve attached file',
  'activity.browseReleasesToRetry': 'Browse releases to retry',
  'activity.browseReleasesToApprove': 'Browse releases to approve',
  'activity.book': 'Book',
  'activity.noAttachedRelease':
    'No attached release data is available. Choose a release before approval.',
  'activity.previousDownloadFailed':
    'Previous download failed. Choose a release before re-approving.',
  'activity.bookRequestWithoutFile':
    'This is a book-level request without an attached file. Choose a release before approval.',
  'activity.clearedReleaseAfterFailure':
    'Previous download failed and the attached release was cleared. Choose a release before re-approving.',
  'activity.hideDetails': 'Hide details',
  'activity.showDetails': 'Show details',
  'activity.requesterCount': '{count} requester(s)',
  'activity.hide': 'hide',
  'activity.show': 'show',
  'activity.userFallback': 'User {id}',
  'activity.selected': 'Selected',
  'activity.findRelease': 'Find release',
  'activity.markAvailable': 'Mark available',
  'activity.rejectSelected': 'Reject selected',
  'onboarding.title': 'Setup',
  'onboarding.dialog': 'Setup wizard',
  'onboarding.close': 'Close setup wizard',
  'onboarding.loading': 'Loading setup wizard…',
  'onboarding.loadFailed': 'Failed to load setup wizard',
  'onboarding.skipped': 'Setup skipped — using defaults',
  'onboarding.skipFailed': 'Failed to skip setup',
  'onboarding.complete': 'Setup complete!',
  'onboarding.saveFailed': 'Failed to save settings',
  'onboarding.noCurrentStep': 'No current step',
  'onboarding.actionFailed': 'Action failed',
  'onboarding.unsupportedField': 'Unsupported onboarding field type: {type}',
  'onboarding.unknownField': 'Unknown field type',
  'onboarding.step': 'Step {current} of {total}',
  'onboarding.skip': 'Skip setup',
  'onboarding.back': 'Back',
  'onboarding.finish': 'Finish setup',
  'onboarding.next': 'Next',
  'settings.close': 'Close settings',
  'settings.restartRequired': 'Some settings require a container restart to take effect',
  'settings.noTabSelected': 'No tab selected',
  'settings.openingUsers': 'Opening Users…',
  'settings.securityLoadFailed': 'Failed to load security settings',
  'settings.selectCategory': 'Select a category to configure',
} as const;

type TranslationKey = keyof typeof en;

const nl: Record<TranslationKey, string> = {
  'nav.discover': 'Ontdekken',
  'nav.dashboard': 'Start',
  'nav.library': 'Mijn bibliotheek',
  'nav.koboSync': 'Kobo-sync',
  'nav.catalog': 'Catalogus',
  'nav.trending': 'Trending',
  'nav.following': 'Volgend',
  'nav.reader': 'Kobo',
  'nav.manage': 'Beheer',
  'nav.downloads': 'Downloads',
  'nav.releaseProfiles': 'Releaseprofielen',
  'nav.requestProcesses': 'Verzoeken',
  'nav.users': 'Gebruikers',
  'nav.operations': 'Systeembeheer',
  'nav.add': 'Boek toevoegen',
  'nav.settings': 'Instellingen',
  'nav.close': 'Navigatie sluiten',
  'nav.open': 'Navigatie openen',
  'header.search': 'Zoek boeken, auteurs of ISBN',
  'header.searchLabel': 'Doorzoek de catalogus',
  'search.loading': 'Lokale boeken zoeken…',
  'search.error': 'Lokale zoekresultaten konden niet worden geladen.',
  'search.empty': 'Geen lokale boeken gevonden.',
  'search.external': 'Zoek extern naar “{query}”',
  'search.inLibrary': 'Mijn bibliotheek',
  'search.catalog': 'Catalogus',
  'search.trending': 'Trending',
  'search.metadata': 'Metadata',
  'header.activity': 'Activiteit',
  'header.userMenu': 'Gebruikersmenu',
  'header.language': 'Taal',
  'header.mySettings': 'Mijn instellingen',
  'header.adminSettings': 'Beheerinstellingen',
  'header.reportBug': 'Probleem melden',
  'issueReport.title': 'Probleem melden',
  'issueReport.intro':
    'Omschrijf wat er misging. Je melding wordt privé naar het BookFlow-team gestuurd.',
  'issueReport.close': 'Probleemmelding sluiten',
  'issueReport.subject': 'Onderwerp',
  'issueReport.pageUrl': 'Pagina-URL',
  'issueReport.description': 'Omschrijving',
  'issueReport.characterCount': '{count} van {max} tekens',
  'issueReport.chooseImage': 'Afbeelding kiezen',
  'issueReport.imageHint':
    'Optioneel: PNG, JPEG of WebP tot 5 MB. Je kunt ook een afbeelding slepen of plakken.',
  'issueReport.imagePreview': 'Voorvertoning van geselecteerde afbeelding',
  'issueReport.removeImage': 'Afbeelding verwijderen',
  'issueReport.imageTypeError': 'Kies een PNG-, JPEG- of WebP-afbeelding.',
  'issueReport.imageSizeError': 'De afbeelding mag maximaal 5 MB groot zijn.',
  'issueReport.requiredError': 'Vul een onderwerp en omschrijving in.',
  'issueReport.submit': 'Probleem indienen',
  'issueReport.submitting': 'Indienen…',
  'issueReport.success': 'Probleem ingediend (#{number})',
  'issueReport.successAttachmentFailed':
    'Probleem ingediend (#{number}), maar de bijlage kon niet worden toegevoegd.',
  'issueReport.submitFailed': 'Het probleem kon niet worden ingediend. Probeer het opnieuw.',
  'header.signOut': 'Uitloggen',
  'header.myself': 'Mijzelf',
  'header.downloadAs': 'Downloaden als',
  'header.downloadingAs': 'Downloaden als {user}',
  'header.loadingUsers': 'Gebruikers laden…',
  'header.restart': 'Herstarten',
  'header.debugGathering': 'Debuglogboeken verzamelen… Dit kan even duren.',
  'header.debugSuccess': 'Debuglogboeken zijn gedownload.',
  'header.debugFailed': 'Downloaden van debuglogboeken mislukt. Controleer de console.',
  'header.debugFailedDetail': 'Downloaden van debuglogboeken mislukt: {error}',
  'nav.primary': 'Hoofdnavigatie',
  'activity.title': 'Activiteit',
  'activity.all': 'Alles',
  'activity.downloads': 'Downloads',
  'activity.requests': 'Aanvragen',
  'activity.history': 'Historie',
  'activity.complete': 'Voltooid',
  'activity.failed': 'Mislukt',
  'activity.inProgress': 'Bezig',
  'activity.needsReview': 'Te beoordelen',
  'activity.waiting': 'Wachtend',
  'activity.noActivity': 'Geen activiteit',
  'activity.noRequests': 'Geen aanvragen',
  'activity.noDownloads': 'Geen downloads',
  'activity.noHistory': 'Geen historie',
  'activity.loadingRequests': 'Aanvragen laden…',
  'activity.loadingHistory': 'Historie laden…',
  'activity.clearCompleted': 'Voltooide wissen',
  'activity.clearHistory': 'Historie wissen',
  'activity.pin': 'Activiteitspanel vastmaken',
  'activity.unpin': 'Activiteitspanel losmaken',
  'activity.filterByUser': 'Filter op gebruiker',
  'activity.filteredByUser': 'Gefilterd op gebruiker {user}',
  'activity.allUsers': 'Alle gebruikers',
  'activity.backToActivity': 'Terug naar activiteit',
  'activity.openHistory': 'Historie openen',
  'activity.close': 'Activiteitspanel sluiten',
  'activity.loadMore': 'Meer laden',
  'interactiveSearch.title': 'Interactief zoeken',
  'interactiveSearch.freshSearch':
    'Een nieuwe handmatige zoekactie toont alle resultaten, ook releases die het actieve profiel overslaat.',
  'interactiveSearch.searching': 'Alle geconfigureerde bronnen worden doorzocht…',
  'interactiveSearch.results': '{count} resultaten',
  'interactiveSearch.searchAgain': 'Opnieuw zoeken',
  'interactiveSearch.refresh': 'Vernieuwen',
  'interactiveSearch.sort': 'Resultaten sorteren',
  'interactiveSearch.sortScore': 'Profielscore',
  'interactiveSearch.sortPeers': 'Seeders / peers',
  'interactiveSearch.sortSize': 'Grootte',
  'interactiveSearch.sortTitle': 'Titel',
  'interactiveSearch.noResults':
    'Nog geen resultaten. Vernieuw nadat de geconfigureerde bronnen hebben gereageerd.',
  'interactiveSearch.release': 'Release',
  'interactiveSearch.source': 'Bron / indexer',
  'interactiveSearch.protocol': 'Protocol',
  'interactiveSearch.size': 'Grootte',
  'interactiveSearch.peers': 'Peers',
  'interactiveSearch.languageFormat': 'Taal / formaat',
  'interactiveSearch.score': 'Score',
  'interactiveSearch.decision': 'Profielbeslissing',
  'interactiveSearch.action': 'Actie',
  'interactiveSearch.eligible': 'Geschikt',
  'interactiveSearch.grab': 'Ophalen',
  'interactiveSearch.grabOverride': 'Ophalen met override',
  'interactiveSearch.showAttempts': 'Downloadpogingen tonen ({count})',
  'interactiveSearch.hideAttempts': 'Downloadpogingen verbergen ({count})',
  'interactiveSearch.noAttempts': 'Nog geen downloadpogingen.',
  'interactiveSearch.close': 'Interactief zoeken sluiten',
  'interactiveSearch.noCover': 'Geen omslag',
  'interactiveSearch.profile': 'Profiel',
  'interactiveSearch.defaultProfile': 'Standaard',
  'interactiveSearch.starting': 'Starten',
  'interactiveSearch.sources': 'Resultaatbronnen',
  'interactiveSearch.allSources': 'Alle',
  'interactiveSearch.filterFormat': 'Filteren op formaat',
  'interactiveSearch.allFormats': 'Alle formaten',
  'interactiveSearch.filterLanguage': 'Filteren op taal',
  'interactiveSearch.allLanguages': 'Alle talen',
  'interactiveSearch.blocked': 'Geblokkeerd',
  'interactiveSearch.rejected': 'Afgewezen door profiel',
  'interactiveSearch.selected': 'Geselecteerd',
  'interactiveSearch.retry': 'Opnieuw proberen',
  'interactiveSearch.retrySuccess': 'Nieuwe downloadpoging ingepland',
  'interactiveSearch.forceConfirm':
    'Deze release is afgewezen door het actieve profiel of de blokkeerlijst. Toch geforceerd ophalen?',
  'interactiveSearch.auditReason': 'Verplichte auditreden voor deze override',
  'interactiveSearch.forceSuccess': 'Release geforceerd opgehaald en audit vastgelegd',
  'interactiveSearch.grabSuccess': 'Release in de downloadwachtrij geplaatst',
  'interactiveSearch.failed': 'Zoeken mislukt.',
  'interactiveSearch.timeout':
    'Het zoeken duurt langer dan verwacht. Vernieuw om deze zoekrun te blijven controleren.',
  'interactiveSearch.unknownSource': 'Onbekende bron',
  'interactiveSearch.status.queued': 'In wachtrij',
  'interactiveSearch.status.running': 'Bezig met zoeken',
  'interactiveSearch.status.completed': 'Voltooid',
  'interactiveSearch.status.partial': 'Gedeeltelijk voltooid',
  'interactiveSearch.status.failed': 'Mislukt',
  'interactiveSearch.attempt.queued': 'In wachtrij',
  'interactiveSearch.attempt.submitted': 'Ingediend bij downloadclient',
  'interactiveSearch.attempt.downloading': 'Bezig met downloaden',
  'interactiveSearch.attempt.importing': 'Bezig met importeren',
  'interactiveSearch.attempt.completed': 'Voltooid',
  'interactiveSearch.attempt.retryScheduled': 'Nieuwe poging gepland',
  'interactiveSearch.attempt.failed': 'Mislukt',
  'interactiveSearch.attempt.cancelled': 'Geannuleerd',
  'common.loading': 'Laden…',
  'common.retry': 'Opnieuw proberen',
  'common.cancel': 'Annuleren',
  'common.close': 'Sluiten',
  'common.save': 'Wijzigingen opslaan',
  'common.saving': 'Opslaan…',
  'common.delete': 'Verwijderen',
  'common.unknownAuthor': 'Onbekende auteur',
  'common.unknown': 'Onbekend',
  'webReader.close': 'Reader sluiten',
  'webReader.download': 'Downloaden',
  'webReader.downloading': 'Downloaden…',
  'webReader.contents': 'Inhoudsopgave',
  'webReader.display': 'Weergave',
  'webReader.fullscreen': 'Volledig scherm',
  'webReader.moreActions': 'Meer readeracties',
  'webReader.readerActions': 'Readeracties',
  'webReader.readingProgress': 'Leesvoortgang',
  'webReader.actionFailed': 'De actie is mislukt.',
  'common.results': '{count} resultaten',
  'common.coverOf': 'Omslag van {title}',
  'common.request': 'Aanvraag',
  'common.requestProcess': 'Verzoek',
  'common.loadFailed': 'Deze pagina kon niet worden geladen.',
  'pwa.updateAvailable': 'Er is een BookFlow-update beschikbaar.',
  'pwa.installPrompt': 'Installeer BookFlow voor snelle toegang.',
  'pwa.refresh': 'Vernieuwen',
  'pwa.install': 'Installeren',
  'pwa.later': 'Later',
  'offline.eyebrow': 'Offline lezen',
  'offline.title': 'Beschikbaar zonder verbinding',
  'offline.status': 'Offline',
  'offline.intro':
    'Deze boeken staan volledig op dit apparaat. Je leesvoortgang wordt gesynchroniseerd zodra BookFlow weer online is.',
  'offline.loading': 'Offline boeken ladenâ€¦',
  'offline.emptyTitle': 'Er zijn nog geen boeken offline beschikbaar',
  'offline.emptyHelp':
    'Maak opnieuw verbinding met BookFlow en wacht tot een boek bij Verder lezen het label Offline toont.',
  'offline.partialFailure':
    '{count} boek(en) konden niet worden vernieuwd. Eerder opgeslagen boeken blijven beschikbaar.',
  'offline.cacheFailure': 'De offline opslag kon niet worden gelezen of vernieuwd.',
  'offline.onlineCacheFailure': '{count} boek(en) konden niet offline beschikbaar worden gemaakt.',
  'offline.retry': 'Opnieuw proberen',
  'offline.availableBadge': 'Offline Â· {progress}%',
  'offline.progress': '{progress}% gelezen',
  'offline.open': 'Verder lezen',
  'dashboard.eyebrow': 'Jouw BookFlow',
  'dashboard.title': 'Fijn dat je er bent',
  'dashboard.subtitle': 'Lees verder waar je gebleven was of ontdek iets nieuws.',
  'dashboard.continue': 'Verder lezen',
  'dashboard.continueEmpty': 'Nog geen actief boek.',
  'dashboard.recent': 'Recent toegevoegd',
  'dashboard.recentEmpty': 'Er zijn nog geen recente toevoegingen.',
  'dashboard.viewLibrary': 'Bekijk bibliotheek',
  'dashboard.viewCatalog': 'Ontdek de catalogus',
  'dashboard.bookFallback': 'Boek',
  'dashboard.trending': 'Trending deze week',
  'dashboard.trendingSubtitle': 'Populaire boeken uit de actuele Nederlandse Bestseller 60.',
  'dashboard.viewTrending': 'Bekijk alles',
  'dashboard.trendingEmpty': 'De wekelijkse bestsellerlijsten zijn nog niet beschikbaar.',
  'dashboard.trendingWeek': 'Week {week}, {year}',
  'dashboard.trendingShelf': 'Trending · Bestseller 60',
  'dashboard.recentRequests': 'Recente aanvragen',
  'dashboard.requestsEmpty': 'Je hebt nog geen boeken aangevraagd.',
  'dashboard.newBadge': 'Nieuw',
  'dashboard.requestBook': 'Boek',
  'dashboard.requestStatus.available': 'Beschikbaar',
  'dashboard.requestStatus.processing': 'In behandeling',
  'dashboard.requestStatus.rejected': 'Afgewezen',
  'dashboard.requestStatus.cancelled': 'Geannuleerd',
  'dashboard.requestStatus.failed': 'Mislukt',
  'dashboard.requestStatus.unknown': 'Onbekend',
  'dashboard.scrollBack': 'terug scrollen',
  'dashboard.scrollForward': 'verder scrollen',
  'dashboard.recentLoadFailed': 'Recent toegevoegde boeken konden niet worden geladen.',
  'dashboard.requestsLoadFailed': 'Recente aanvragen konden niet worden geladen.',
  'dashboard.readingLoadFailed': 'Leesvoortgang kon niet worden geladen.',
  'dashboard.trendingLoadFailed': 'Trending boeken konden niet worden geladen.',
  'suggestions.eyebrow': 'Trending',
  'suggestions.title': 'Boeksuggesties',
  'suggestions.back': 'Terug naar start',
  'suggestions.loading': 'Suggesties laden…',
  'suggestions.invalid': 'Deze suggestielijst bestaat niet.',
  'suggestions.loadFailed': 'Suggesties konden niet worden geladen.',
  'suggestions.empty': 'Er zijn nog geen boeksuggesties beschikbaar.',
  'suggestions.loadMore': 'Meer suggesties laden',
  'suggestions.loadingMore': 'Meer suggesties laden…',
  'suggestions.list.overall': 'Bestseller 60',
  'suggestions.list.fiction': 'Fictie',
  'suggestions.list.non_fiction': 'Non-fictie',
  'suggestions.list.thriller': 'Spanning',
  'suggestions.list.youth': 'Jeugd',
  'suggestions.list.cooking': 'Culinair',
  'library.eyebrow': 'Mijn bibliotheek',
  'library.title': 'Jouw boeken',
  'library.koboTitle': 'Kobo-sync',
  'library.summary': '{count} opgeslagen {works}',
  'library.work': 'boek',
  'library.works': 'boeken',
  'library.waiting': ', {count} wacht nog op bestanden.',
  'library.search': 'Zoek op titel of auteur',
  'library.fileState': 'Beschikbaarheid bestanden',
  'library.all': 'Alles',
  'library.hasFiles': 'Beschikbaar',
  'library.needsFiles': 'Mist bestanden',
  'library.format': 'Bestandsformaat',
  'library.allFormats': 'Alle formaten',
  'library.sort': 'Bibliotheek sorteren',
  'library.sortRecent': 'Recent toegevoegd',
  'library.sortTitle': 'Titel',
  'library.sortAuthor': 'Auteur',
  'library.sortYear': 'Publicatiejaar',
  'library.grid': 'Raster',
  'library.list': 'Lijst',
  'library.pageResults': '{from}–{to} van {total}',
  'library.pagination': 'Paginering bibliotheek',
  'library.previous': 'Vorige',
  'library.next': 'Volgende',
  'library.empty': 'Je bibliotheek is leeg',
  'library.emptyHelp': 'Zoek een boek in de catalogus en voeg het toe aan je bibliotheek.',
  'library.noMatch': 'Geen boeken passen bij deze zoekopdracht en dit filter.',
  'library.noMatchHelp': 'Pas de zoekopdracht of filters aan en probeer opnieuw.',
  'library.untitled': 'Boek zonder titel',
  'catalog.eyebrow': 'Ontdekken',
  'catalog.title': 'Bekijk alle boeken',
  'bulkLibrary.select': 'Boeken selecteren',
  'bulkLibrary.cancelSelection': 'Stoppen met selecteren',
  'bulkLibrary.actions': 'Bulkacties voor je bibliotheek',
  'bulkLibrary.selected': '{count} geselecteerd',
  'bulkLibrary.selectPage': 'Deze pagina selecteren',
  'bulkLibrary.clear': 'Wissen',
  'bulkLibrary.addSelected': '{count} toevoegen aan bibliotheek',
  'bulkLibrary.retrySelected': '{count} mislukte opnieuw proberen',
  'bulkLibrary.adding': 'Toevoegen…',
  'bulkLibrary.inLibrary': 'In bibliotheek',
  'bulkLibrary.selectBook': '{title} selecteren',
  'bulkLibrary.deselectBook': 'Selectie van {title} opheffen',
  'bulkLibrary.limit': 'Je kunt maximaal 100 boeken tegelijk selecteren.',
  'bulkLibrary.result': '{added} toegevoegd, {existing} al in je bibliotheek, {failed} mislukt.',
  'bulkLibrary.unavailableDetails': 'Geen geïmporteerd ebookbestand: {ids}.',
  'bulkLibrary.notFoundDetails': 'Niet meer gevonden: {ids}.',
  'catalog.subtitle':
    'Ontdek de gedeelde collectie. Bestanden en leesvoortgang blijven persoonlijk.',
  'catalog.search': 'Zoek titel, auteur, serie of ISBN',
  'catalog.allFormats': 'Alle formaten',
  'catalog.formatLabel': 'Filter op formaat',
  'catalog.recent': 'Recent toegevoegd',
  'catalog.titleSort': 'Titel',
  'catalog.authorSort': 'Auteur',
  'catalog.yearSort': 'Publicatiejaar',
  'catalog.sortLabel': 'Sorteer catalogus',
  'catalog.list': 'Lijst',
  'catalog.grid': 'Raster',
  'catalog.loading': 'Catalogus laden…',
  'catalog.empty': 'Geen boeken gevonden.',
  'catalog.previous': 'Vorige',
  'catalog.next': 'Volgende',
  'catalog.externalHelp': 'Zoek pas buiten je catalogus wanneer het boek hierboven ontbreekt.',
  'catalog.browseAuthors': 'Bekijk auteurs',
  'catalog.browseSeries': 'Bekijk series',
  'catalog.clearFilter': 'Catalogusfilter wissen',
  'catalog.entityBooks': '{count} boeken',
  'catalog.entityEmpty': 'Geen {kind} gevonden.',
  'catalog.entitySearch': 'Zoek {kind}',
  'catalog.books': 'Boeken',
  'catalogDetail.back': 'Terug naar catalogus',
  'catalogDetail.backLibrary': 'Terug naar mijn bibliotheek',
  'catalogDetail.backKobo': 'Terug naar Kobo Sync',
  'catalogDetail.backTrending': 'Terug naar Trending',
  'catalogDetail.shared': 'Gedeelde catalogus',
  'catalogDetail.openPersonal': 'Open persoonlijk boek',
  'catalogDetail.readNow': 'Nu lezen',
  'catalogDetail.downloading': 'Downloaden…',
  'catalogDetail.requestBook': 'Dit boek aanvragen',
  'catalogDetail.requestCreated': 'Aanvraag aangemaakt.',
  'catalogDetail.requestFailed': 'Aanvraag mislukt',
  'catalogDetail.addBook': 'Toevoegen aan mijn bibliotheek',
  'catalogDetail.adding': 'Toevoegen…',
  'catalogDetail.added': 'Toegevoegd aan je bibliotheek.',
  'catalogDetail.addFailed': 'Dit boek kon niet worden toegevoegd',
  'catalogDetail.addConfirmTitle': 'Boek aan je bibliotheek toevoegen?',
  'catalogDetail.addConfirmDescription': 'Voeg “{title}” toe aan je persoonlijke bibliotheek.',
  'catalogDetail.checkingKobo': 'Je Kobo-syncinstellingen worden gecontroleerd…',
  'catalogDetail.addToKobo': 'Dit boek ook meteen aan Kobo-sync toevoegen',
  'catalogDetail.addKoboNoFile': 'Er is geen geschikt bestand beschikbaar voor Kobo-sync.',
  'catalogDetail.addedKoboFailed':
    'Het boek is aan je bibliotheek toegevoegd, maar Kobo-sync is mislukt: {error}',
  'catalogDetail.description': 'Beschrijving',
  'catalogDetail.noDescription': 'Geen beschrijving beschikbaar.',
  'catalogDetail.statusAvailable': 'Beschikbaar',
  'catalogDetail.statusInLibrary': 'In je bibliotheek',
  'catalogDetail.statusRequested': 'Aangevraagd',
  'catalogDetail.statusNotAdded': 'Niet in je bibliotheek',
  'catalogDetail.published': 'Verschenen',
  'catalogDetail.language': 'Taal',
  'catalogDetail.pages': "Pagina's",
  'catalogDetail.publisher': 'Uitgever',
  'catalogDetail.formats': 'Formaten',
  'catalogDetail.isbn': 'ISBN',
  'catalogDetail.seriesPart': 'Deel {position}',
  'catalogDetail.personalTitle': 'Jouw boek',
  'catalogDetail.personalHelp': 'Jouw persoonlijke beschikbaarheid en leesstatus.',
  'catalogDetail.readingProgress': 'Leesvoortgang',
  'catalogDetail.continueReading': 'Verder lezen',
  'catalogDetail.catalogAvailability': 'Beschikbaar in catalogus',
  'catalogDetail.available': 'Beschikbaar',
  'catalogDetail.notAvailable': 'Nog niet beschikbaar',
  'catalogDetail.removeFromLibrary': 'Verwijderen uit mijn bibliotheek',
  'catalogDetail.deleteCatalog': 'Uit catalogus verwijderen',
  'catalogDetail.deleteCatalogConfirm': 'Catalogus definitief verwijderen',
  'catalogDetail.deleteCatalogTyped': 'Typ de boektitel om te bevestigen',
  'catalogDetail.cleanupPending': 'Catalogus verwijderd; bestandsopruiming wacht nog.',
  'catalogDetail.retryCleanup': 'Opruiming opnieuw proberen',
  'catalogDetail.removeLibraryConfirm':
    'Dit verwijdert het boek uit je bibliotheek en, indien van toepassing, uit Kobo-sync.',
  'catalogDetail.removedFromLibrary': 'Verwijderd uit je bibliotheek.',
  'catalogDetail.removing': 'Verwijderen…',
  'catalogDetail.confirm': 'Bevestig',
  'catalogDetail.addedOn': 'Toegevoegd aan bibliotheek',
  'catalogDetail.requestStatus': 'Aanvraagstatus',
  'catalogDetail.requestUpdated': 'Laatst bijgewerkt',
  'catalogDetail.availableFiles': 'Beschikbare bestanden',
  'catalogDetail.fileCount': '{count} bestanden',
  'catalogDetail.noFormats': 'Nog geen bestanden beschikbaar',
  'catalogDetail.kobo': 'Kobo',
  'catalogDetail.koboActive': 'Gesynchroniseerd',
  'catalogDetail.koboDeleted': 'Verwijderd van Kobo',
  'catalogDetail.koboNotSynced': 'Niet gesynchroniseerd',
  'catalogDetail.request.pending_approval': 'Wacht op goedkeuring',
  'catalogDetail.request.approved': 'Goedgekeurd',
  'catalogDetail.request.fulfilled': 'Beschikbaar',
  'catalogDetail.request.rejected': 'Afgewezen',
  'catalogDetail.request.cancelled': 'Geannuleerd',
  'catalogDetail.reportTitle': 'Foute metadata?',
  'catalogDetail.reportHelp': 'Meld een veld voor beoordeling door een beheerder.',
  'catalogDetail.reportPlaceholder': 'Wat klopt er niet?',
  'catalogDetail.report': 'Melden',
  'catalogDetail.reportSent': 'Metadata-melding verstuurd.',
  'catalogDetail.reportFailed': 'Metadata-melding kon niet worden verstuurd',
  'metadata.field.title': 'Titel',
  'metadata.field.author': 'Auteur',
  'metadata.field.series': 'Serie',
  'metadata.field.description': 'Beschrijving',
  'metadata.field.cover': 'Omslag',
  'following.eyebrow': 'Volgend',
  'following.title': 'Auteurs en series',
  'following.subtitle': 'Laat BookFlow nieuwe titels zoeken en kies wat er daarna gebeurt.',
  'following.placeholder': 'Naam van auteur of serie',
  'following.searchProfile': 'Zoekprofiel',
  'following.searchProfileHelp': 'Naam of zoekterm die de gekozen metadataprovider gebruikt.',
  'following.type': 'Type monitor',
  'following.provider': 'Provider',
  'following.providerId': 'Provider-id',
  'following.providerIdPlaceholder': 'Optionele provider-id',
  'following.providerIdHelp': 'Gebruik dit als je de provider-specifieke auteur- of serie-id kent.',
  'following.unknownProvider': 'Onbekende provider',
  'following.scanSchedule': 'Scanschema',
  'following.scanEveryHours': 'Elke {hours} uur',
  'following.scanEveryMinutes': 'Elke {minutes} minuten',
  'following.action': 'Bij ontdekking',
  'following.author': 'Auteur',
  'following.series': 'Serie',
  'following.notify': 'Melden',
  'following.request': 'Aanvragen',
  'following.acquire': 'Automatisch ophalen',
  'following.acquireRestricted': 'Automatisch ophalen vereist downloadrechten.',
  'following.add': 'Begin met volgen',
  'following.results': 'Resultaten',
  'following.scan': 'Nu scannen',
  'following.resume': 'Hervatten',
  'following.pause': 'Pauzeren',
  'following.nextScan': 'Volgende scan: {date}',
  'following.scanScheduled': 'Scan ingepland',
  'following.empty': 'Je volgt nog geen auteurs of series.',
  'following.noDiscoveries': 'Nog geen titels ontdekt.',
  'following.koboIntent': 'Voeg ontdekte boeken toe aan Kobo wanneer beschikbaar',
  'following.koboOn': 'Kobo aan',
  'following.koboOff': 'Kobo uit',
  'following.state.discovered': 'Nieuw ontdekt',
  'following.state.present': 'Al aanwezig',
  'following.state.future': 'Toekomstig',
  'following.state.requested': 'Aangevraagd',
  'following.state.ignored': 'Genegeerd',
  'following.ignoreDiscovery': 'Negeren',
  'following.restoreDiscovery': 'Herstellen',
  'following.discoveryUpdateFailed': 'De ontdekking kon niet worden bijgewerkt.',
  'reader.eyebrow': 'Persoonlijk',
  'reader.title': 'Kobo',
  'reader.subtitle': 'Koppel je Kobo en beheer browsermeldingen per apparaat.',
  'reader.notificationsSubtitle': 'Beheer browsermeldingen voor dit account en dit apparaat.',
  'reader.patcherTitle': 'Windows Kobo-patcher',
  'reader.patcherHelp':
    'Download de Windows-app en log in met je BookFlow-account. De wizard helpt je bij het aansluiten, kiezen en instellen van je Kobo. Voor externe login kun je ook een koppelcode gebruiken.',
  'reader.downloadPatcher': 'Windows-patcher downloaden',
  'reader.generateCode': 'Genereer koppelcode',
  'reader.oneTimeCode': 'Eenmalige koppelcode',
  'reader.copy': 'Kopieer',
  'reader.codeValidUntil': 'Geldig tot {expiresAt}. Deel deze code met niemand.',
  'reader.soon': 'binnenkort',
  'reader.patcherNote':
    'De patcher kan een originele configuratieback-up herstellen of zonder back-up alleen de officiële Kobo-sync terugzetten.',
  'reader.webPush': 'Web-push',
  'reader.webPushHelp': 'Meldingen voor monitoren, aanvragen en beschikbare boeken.',
  'reader.enablePush': 'Meldingen inschakelen',
  'reader.browserDevice': 'Browserapparaat',
  'reader.noDevices': 'Geen geregistreerde browserapparaten.',
  'reader.notificationTypes': 'Meldingstypen',
  'reader.notificationTypesHelp': 'Deze keuzes gelden voor Web Push en Apprise.',
  'reader.sendTest': 'Testmelding sturen',
  'reader.pairingCreated': 'Koppelcode aangemaakt. Deze is eenmalig en tijdelijk.',
  'reader.pairingFailed': 'De koppelcode kon niet worden aangemaakt.',
  'reader.pushUnsupported': 'Deze browser ondersteunt geen web-push.',
  'reader.pushDenied': 'Browsermeldingen zijn niet toegestaan.',
  'reader.pushUnconfigured': 'Web-push is nog niet door de beheerder geconfigureerd.',
  'reader.pushEnabled': 'Browsermeldingen zijn ingeschakeld.',
  'reader.pushFailed': 'Web-push kon niet worden ingeschakeld.',
  'reader.ruleSaveFailed': 'De meldingsregel kon niet worden opgeslagen.',
  'reader.ruleSaved': 'Meldingsregel opgeslagen.',
  'reader.saveFilters': 'Filters opslaan',
  'reader.testSent': 'Testmelding verzonden naar {count} apparaat/apparaten.',
  'reader.testFailed': 'De testmelding kon niet worden verzonden.',
  'reader.eventMonitor': 'Nieuwe titel van auteur of serie',
  'reader.eventRequest': 'Status van een aanvraag',
  'reader.eventAvailable': 'Boek is beschikbaar',
  'reader.eventRequestError': 'Download of verwerking mislukt',
  'reader.eventMetadata': 'Status van metadata-melding',
  'reader.eventBackupError': 'Back-upfout',
  'reader.patcherUnavailable': 'Patcher niet beschikbaar',
  'reader.version': 'Protocolversie {version}',
  'reader.manualConfiguration': 'Handmatige configuratie',
  'reader.manualConfigurationHelp':
    'Open .kobo/Kobo/Kobo eReader.conf en stel api_endpoint in [OneStoreServices] in op je persoonlijke endpoint dat eindigt op {suffix}. Maak eerst een kopie; dit wijzigt Kobo Store/OverDrive-gedrag.',
  'reader.filtersInvalid': 'Filters moeten een JSON-object zijn.',
  'reader.filtersLabel': 'Filters voor {event}',
  'koboPanel.title': 'Kobo-synchronisatie',
  'koboPanel.subtitle': 'Beheer Kobo-sync en de e-readers die aan je account zijn gekoppeld.',
  'koboPanel.loading': 'Kobo-instellingen laden…',
  'koboPanel.loadFailed': 'De Kobo-instellingen konden niet worden geladen.',
  'koboPanel.enable': 'Kobo-sync inschakelen',
  'koboPanel.enableHelp':
    'Schakel dit uit om te voorkomen dat gekoppelde e-readers bibliotheekupdates ontvangen.',
  'koboPanel.enabledToast': 'Kobo-sync is ingeschakeld.',
  'koboPanel.disabledToast': 'Kobo-sync is uitgeschakeld.',
  'koboPanel.updateFailed': 'Kobo-sync kon niet worden bijgewerkt.',
  'koboPanel.devices': 'Gekoppelde e-readers',
  'koboPanel.devicesHelp':
    'Gebruik de Windows-patcher en log in met je BookFlow-account om een reader te koppelen.',
  'koboPanel.noDevices': 'Er zijn geen actieve Kobo-e-readers gekoppeld.',
  'koboPanel.unnamedDevice': 'Naamloze Kobo-e-reader',
  'koboPanel.created': 'Aangemaakt op {date}',
  'koboPanel.lastUsed': 'Laatst gebruikt op {date}',
  'koboPanel.never': 'nooit',
  'koboPanel.revoke': 'Intrekken',
  'koboPanel.confirmRevoke': 'Intrekken bevestigen',
  'koboPanel.revoking': 'Intrekken…',
  'koboPanel.revokeConfirm':
    'Deze e-reader intrekken? Synchroniseren kan pas weer nadat deze opnieuw is gekoppeld.',
  'koboPanel.revokedToast': 'Kobo-e-reader ingetrokken.',
  'koboPanel.revokeFailed': 'De Kobo-e-reader kon niet worden ingetrokken.',
  'settings.title': 'Mijn instellingen',
  'settings.account': 'Account',
  'settings.username': 'Gebruikersnaam',
  'settings.email': 'E-mailadres van account',
  'settings.password': 'Wachtwoord',
  'settings.envControlled': 'Deze instelling wordt beheerd door een omgevingsvariabele',
  'settings.unavailable': 'Niet beschikbaar',
  'settings.restartHelp': 'Na deze wijziging moet de container opnieuw worden gestart',
  'settings.andMore': 'en nog {count}…',
  'settings.userOverridden': 'Door gebruiker overschreven',
  'settings.reset': 'Herstellen',
  'settings.moveUp': 'Omhoog verplaatsen',
  'settings.moveDown': 'Omlaag verplaatsen',
  'settings.removeRow': 'Rij verwijderen',
  'settings.unknownCustomComponent': 'Onbekend instellingenonderdeel: {component}',
  'settings.unknownFieldType': 'Onbekend veldtype',
  'settings.displayName': 'Weergavenaam',
  'settings.language': 'Interfacetaal',
  'settings.languageHelp': 'BookFlow gebruikt deze taal wanneer je inlogt.',
  'settings.notifications': 'Persoonlijke meldingen',
  'settings.enableNotifications': 'Persoonlijke meldingen inschakelen',
  'settings.testDestination': 'Opgeslagen bestemming testen',
  'settings.sendingTest': 'Test versturen…',
  'settings.updated': 'Instellingen bijgewerkt',
  'settings.theme': 'Thema',
  'settings.themeHelp': 'Kies hoe BookFlow er op dit apparaat uitziet.',
  'settings.themeSystem': 'Systeeminstelling gebruiken',
  'settings.themeLight': 'Licht',
  'settings.themeDark': 'Donker',
  'settings.loadFailed': 'De instellingen konden niet worden geladen.',
  'settings.saveFailed': 'De instellingen konden niet worden bijgewerkt.',
  'settings.testFailed': 'De testmelding kon niet worden verzonden.',
  'header.languageSaveFailed': 'De taalvoorkeur kon niet worden opgeslagen',
  'language.en': 'English',
  'language.nl': 'Nederlands',
  'login.welcome': 'Welkom bij BookFlow',
  'login.subtitle': 'Log in om verder te gaan naar je bibliotheek.',
  'login.username': 'Gebruikersnaam',
  'login.password': 'Wachtwoord',
  'login.remember': 'Onthoud mij 7 dagen',
  'login.signIn': 'Inloggen',
  'login.signingIn': 'Inloggen…',
  'login.showPassword': 'Wachtwoord tonen',
  'login.hidePassword': 'Wachtwoord verbergen',
  'login.usePassword': 'Wachtwoord gebruiken',
  'login.hide': 'Verbergen',
  'admin.defaultLanguage': 'Standaard interfacetaal',
  'admin.defaultLanguageHelp':
    'Taal voor nieuw aangemaakte gebruikers. Bestaande gebruikers behouden hun persoonlijke voorkeur.',
  'admin.operationsEyebrow': 'Beheer',
  'admin.usersEyebrow': 'Beheer',
  'admin.usersTitle': 'Gebruikers',
  'admin.usersSubtitle':
    'Beheer accounts, inlogsessies, IP-adressen, downloadhistorie en Kobo-synchronisaties.',
  'admin.viewAudit': 'Activiteit & audit',
  'admin.hideAudit': 'Activiteit verbergen',
  'admin.editUser': 'Bewerken',
  'admin.openUserProfile': 'Profiel van {username} openen',
  'admin.userProfileEyebrow': 'Gebruikersprofiel',
  'admin.backToUsers': 'Terug naar gebruikers',
  'admin.userLoading': 'Gebruikersprofiel laden…',
  'admin.userLoadFailed': 'Het gebruikersprofiel kon niet worden geladen.',
  'admin.userNotFound': 'Gebruiker niet gevonden.',
  'admin.allUsers': 'Alle gebruikers',
  'admin.userCount': '{count} gebruikers',
  'admin.searchUsers': 'Zoeken',
  'admin.searchUsersPlaceholder': 'Gebruikers zoeken…',
  'admin.userColumn': 'Gebruiker',
  'admin.emailColumn': 'E-mail',
  'admin.authColumn': 'Authenticatie',
  'admin.roleColumn': 'Rol',
  'admin.statusColumn': 'Status',
  'admin.createdColumn': 'Aangemaakt',
  'admin.actionsColumn': 'Acties',
  'admin.activeStatus': 'Actief',
  'admin.inactiveStatus': 'Inactief',
  'admin.noMatchingUsers': 'Geen overeenkomende gebruikers gevonden.',
  'admin.loadingUsers': 'Gebruikers laden…',
  'admin.noUsers': 'Nog geen gebruikers.',
  'admin.noUsersHelp':
    'Maak een lokaal beheerdersaccount aan voordat je OIDC inschakelt, zodat je niet wordt buitengesloten.',
  'admin.loadingUserDetails': 'Gebruikersgegevens laden…',
  'admin.createLocalUser': 'Lokale gebruiker aanmaken',
  'admin.noEmail': 'Geen e-mailadres',
  'admin.inactiveAuthMode': 'Inactief voor de huidige authenticatiemodus',
  'admin.saveChanges': 'Wijzigingen opslaan',
  'admin.savingChanges': 'Opslaan…',
  'admin.deletingUser': 'Verwijderen…',
  'admin.confirmDeleteUser': 'Verwijderen bevestigen',
  'admin.deleteUser': 'Gebruiker verwijderen',
  'admin.roleAdmin': 'Beheerder',
  'admin.roleUser': 'Gebruiker',
  'admin.minimumFourCharacters': 'Minimaal 4 tekens',
  'admin.confirmPassword': 'Wachtwoord bevestigen',
  'admin.firstAccountHelp': 'Dit eerste account wordt als beheerder aangemaakt.',
  'admin.oidcAdminRequired':
    'Er is een beheerdersaccount vereist voordat OIDC kan worden ingeschakeld.',
  'admin.creatingUser': 'Aanmaken…',
  'admin.libraryCapability': 'Bibliotheektoegang',
  'admin.autoApproveRequests': 'Eigen verzoeken automatisch goedkeuren',
  'admin.autoApproveRequestsHelp': 'Dit geeft geen administratorrechten.',
  'admin.requestOnly': 'Alleen aanvragen',
  'admin.downloadCapable': 'Downloads en aanvragen',
  'admin.activeAccount': 'Actief account',
  'admin.newPassword': 'Nieuw wachtwoord',
  'admin.keepPasswordHelp': 'Laat leeg om het huidige wachtwoord te behouden',
  'admin.confirmNewPassword': 'Nieuw wachtwoord bevestigen',
  'admin.displayNameManaged': 'De weergavenaam wordt beheerd door de identiteitsprovider.',
  'admin.emailSyncedCwa': 'Het e-mailadres wordt gesynchroniseerd vanuit Calibre-Web.',
  'admin.emailManaged': 'Het e-mailadres wordt beheerd door de identiteitsprovider.',
  'admin.roleManagedByGroup': 'De rol wordt beheerd door de identiteitsprovidergroep {group}.',
  'admin.roleManagedByOidc': 'De rol wordt beheerd via OIDC-groepsautorisatie.',
  'admin.roleAdminsOnly': 'Alleen beheerders kunnen deze rol wijzigen.',
  'admin.roleManagedExternally': 'De rol wordt beheerd door de externe authenticatiebron.',
  'admin.roleCannotChange': 'De rol kan niet worden gewijzigd.',
  'admin.userPreferences': 'Gebruikersvoorkeuren',
  'admin.openUserPreferences': 'Gebruikersvoorkeuren openen',
  'admin.operationsTitle': 'Metadata en back-ups',
  'admin.reportsTitle': 'Metadata-meldingen',
  'admin.reportsHelp': 'Controleer gemelde gegevens voordat je een revision toepast.',
  'admin.openReports': '{count} openstaand',
  'admin.bookNumber': 'Boek #{number}',
  'admin.noReports': 'Geen openstaande meldingen.',
  'admin.current': 'Huidig',
  'admin.manualValue': 'Handmatige waarde (of kies hierboven een kandidaat)',
  'admin.newValue': 'Nieuwe waarde voor {field}',
  'admin.preview': 'Diff bekijken',
  'admin.apply': 'Toepassen',
  'admin.reject': 'Afwijzen',
  'admin.history': 'Historie',
  'admin.backupsTitle': 'Back-upcentrum',
  'admin.createBackup': 'Nu back-up maken',
  'admin.download': 'Downloaden',
  'admin.restore': 'Herstellen',
  'admin.confirmRestore': 'Herstel bevestigen',
  'admin.verify': 'Verifiëren',
  'admin.encrypted': 'versleuteld',
  'admin.unencrypted': 'niet versleuteld',
  'admin.verified': 'geverifieerd',
  'admin.unverified': 'nog niet geverifieerd',
  'admin.noExplanation': 'Geen toelichting gegeven.',
  'admin.revision': 'Revisie {number}',
  'admin.revert': 'Terugzetten',
  'admin.historyLookupTitle': 'Revisiegeschiedenis',
  'admin.historyLookupHelp':
    'Laad de volledige herkomst en zet voor elk boek een eerdere revisie terug.',
  'admin.historyBookId': 'Boek-id',
  'admin.loadHistory': 'Geschiedenis laden',
  'admin.historyInvalidBookId': 'Vul een geldig boek-id in.',
  'admin.historyLoadFailed': 'De revisiegeschiedenis kon niet worden geladen.',
  'admin.historyEmpty': 'Geen metadatarevisies voor dit boek.',
  'admin.actor': 'Uitvoerder',
  'admin.systemActor': 'Systeem',
  'admin.source': 'Bron',
  'admin.reason': 'Reden',
  'admin.appliedAt': 'Toegepast',
  'admin.before': 'Voor',
  'admin.after': 'Na',
  'admin.noFieldChanges': 'Geen veldwijzigingen vastgelegd.',
  'admin.revertFailed': 'Deze revisie kon niet worden teruggezet.',
  'admin.revertReason': 'Revisie {number} teruggezet vanuit de beheergeschiedenis.',
  'admin.backupHelp': 'Alleen database en configuratie; ebookbestanden zijn uitgesloten.',
  'admin.noBackups': 'Nog geen back-ups.',
  'admin.backupFailed': 'Back-upactie mislukt.',
  'admin.previewFailed': 'De diff kon niet worden voorbereid.',
  'admin.applyFailed': 'De metadatarevisie kon niet worden toegepast.',
  'admin.restoreStaged': 'Herstel ingepland voor de volgende start van de applicatie.',
  'admin.restoreFailed': 'Het herstel kon niet worden ingepland.',
  'admin.currentCover': 'Huidige omslag',
  'admin.providerCover': 'Omslag van {source}',
  'progress.title': 'Leesvoortgang',
  'progress.help': 'Alleen actieve boeken staan op je dashboard. 100% verwijdert dit boek daaruit.',
  'progress.label': 'Leesvoortgang percentage',
  'progress.saved': 'Leesvoortgang opgeslagen',
  'progress.resetSaved': 'Leesvoortgang opnieuw ingesteld',
  'progress.reset': 'Herstellen',
  'progress.save': 'Opslaan',
  'metadataReport.title': 'Foute metadata?',
  'metadataReport.help':
    'Meld een veld; een beheerder beoordeelt de wijziging voordat die wordt toegepast.',
  'metadataReport.placeholder': 'Wat klopt er niet?',
  'metadataReport.sent': 'Metadata-melding verstuurd',
  'bookDetail.noCover': 'Geen omslag',
  'bookDetail.inLibrary': 'In je bibliotheek',
  'bookDetail.unknownTitle': 'Boek zonder titel',
  'bookDetail.availableFiles': 'Beschikbare bestanden',
  'bookDetail.sizeUnknown': 'Grootte onbekend',
  'bookDetail.download': 'Downloaden',
  'bookDetail.releaseDownloading': 'Er wordt een release gedownload.',
  'bookDetail.noFiles': 'Er zijn nog geen bestanden beschikbaar.',
  'bookDetail.persistedDelivery': 'Opgeslagen bezorgstatus',
  'bookDetail.requestStatus': 'Aanvraag: {status}',
  'bookDetail.requestProcessStatus': 'Verzoek: {status}',
  'bookDetail.nextSearch': 'Volgende zoekopdracht: {date}',
  'bookDetail.koboStatus': 'Kobo: {status}',
  'bookDetail.koboNotAdded': 'niet toegevoegd',
  'bookDetail.removeFromKobo': 'Van Kobo verwijderen',
  'bookDetail.addToKobo': 'Aan Kobo toevoegen',
  'bookDetail.removedFromKobo': 'Van Kobo verwijderd',
  'bookDetail.addedToKobo': 'Aan Kobo toegevoegd',
  'bookDetail.availability': 'Beschikbaarheid',
  'bookDetail.filesAvailable': 'Er zijn bestanden beschikbaar voor dit boek.',
  'bookDetail.about': 'Over dit boek',
  'bookDetail.noDescription':
    'Er is geen beschrijving beschikbaar van de metadataprovider van dit boek.',
  'bookDetail.backToLibrary': 'Terug naar bibliotheek',
  'bookDetail.retry': 'Opnieuw proberen',
  'bookDetail.filesHelp': 'Het nieuwste gedownloade bestand per formaat.',
  'bookDetail.findRelease': 'Andere release zoeken',
  'bookDetail.unknownSource': 'Onbekende bron',
  'bookDetail.advancedReleases': 'Geavanceerd: alle releases tonen',
  'bookDetail.unlinkRelease': 'Release ontkoppelen',
  'bookDetail.releaseFileCount': '{count} bestand(en) in deze release',
  'bookDetail.grabbedAt': 'Opgehaald op {date}',
  'bookDetail.requestMissingFiles':
    'Er zijn nog geen bestanden beschikbaar. Vraag dit boek aan; een beheerder zoekt een release.',
  'bookDetail.requestBook': 'Dit boek aanvragen',
  'bookDetail.requestPending': 'Aanvraag wacht op goedkeuring',
  'bookDetail.requestProcessInProgress': 'Verzoek wordt verwerkt',
  'bookDetail.requestCancelled': 'Aanvraag geannuleerd',
  'bookDetail.bookAvailable': 'Boek beschikbaar',
  'bookDetail.requestDeclined': 'Aanvraag afgewezen',
  'bookDetail.cancelRequest': 'Aanvraag annuleren',
  'bookDetail.bookRequested': 'Boek aangevraagd',
  'bookDetail.downloadStarted': 'Download gestart',
  'bookDetail.releaseUnlinked': 'Release ontkoppeld',
  'requestProcesses.title': 'Verzoeken',
  'requestProcesses.help':
    'Opgeslagen zoekopdrachten, kandidaten, pogingen, monitoring en herstel.',
  'requestProcesses.loadFailed': 'Verzoeken konden niet worden geladen',
  'requestProcesses.maintenance': 'Onderhoudsstatus',
  'requestProcesses.database': 'Database {status}',
  'requestProcesses.healthy': 'gezond',
  'requestProcesses.needsAttention': 'heeft aandacht nodig',
  'requestProcesses.migrations': '{count} migraties',
  'requestProcesses.pendingJobs': '{count} openstaande taken',
  'requestProcesses.ready': 'Gereed',
  'requestProcesses.attention': 'Aandacht vereist',
  'requestProcesses.migrationHistory': 'Migratiehistorie',
  'requestProcesses.pendingRequests': 'Openstaande verzoeken',
  'requestProcesses.requestNumber': 'Verzoek #{number}',
  'requestProcesses.approve': 'Goedkeuren',
  'requestProcesses.reject': 'Afwijzen',
  'requestProcesses.approvalFailed': 'Goedkeuren mislukt',
  'requestProcesses.rejectionFailed': 'Afwijzen mislukt',
  'requestProcesses.noPendingRequests': 'Geen verzoeken wachten op goedkeuring.',
  'requestProcesses.bookNumber': 'Boek #{number}',
  'requestProcesses.nextSearch': 'Volgende zoekopdracht: {date}',
  'requestProcesses.notScheduled': 'niet ingepland',
  'requestProcesses.searchFailed': 'Zoeken mislukt',
  'requestProcesses.searchNow': 'Nu zoeken',
  'requestProcesses.unmonitor': 'Niet meer volgen',
  'requestProcesses.monitor': 'Volgen',
  'requestProcesses.details': 'Details',
  'requestProcesses.candidates': 'Kandidaten',
  'requestProcesses.attempts': 'Pogingen',
  'requestProcesses.unknown': 'onbekend',
  'requestProcesses.score': 'score {score}',
  'requestProcesses.accepted': 'geaccepteerd',
  'requestProcesses.rejected': 'afgewezen',
  'requestProcesses.retries': 'pogingen {count}',
  'requestProcesses.none': 'Nog geen verzoeken.',
  'requests.requestedBy': 'Aangevraagd door',
  'requests.requestedByCount': 'Aangevraagd door {count} gebruikers',
  'requests.unknownRequester': 'Onbekende gebruiker',
  'requests.requesterList': 'Aanvragers',
  'requests.cancelProcess': 'Proces annuleren (alle aanvragers)',
  'manualUpload.choose': 'EPUB uploaden',
  'manualUpload.confirm': 'Bestand importeren',
  'manualUpload.uploading': 'Uploaden…',
  'manualUpload.complete': 'EPUB geïmporteerd en aanvragen voltooid.',
  'manualUpload.failed': 'De EPUB kon niet worden geïmporteerd.',
  'bookAdd.title': 'Boek toevoegen',
  'bookAdd.close': 'Boek-toevoegenvenster sluiten',
  'bookAdd.search': 'Titel of auteur',
  'bookAdd.searching': 'Zoeken…',
  'bookAdd.searchFailed': 'Boeken konden niet worden gezocht',
  'bookAdd.openFailed': 'Dit boek kon niet worden geopend',
  'bookAdd.opening': 'Openen…',
  'bookAdd.view': 'Details bekijken',
  'bookAdd.external': 'Extern boek zoeken',
  'common.back': 'Terug',
  'common.selectOption': 'Kies een optie',
  'common.select': 'Selecteren…',
  'common.actionFailed': 'Actie mislukt',
  'common.running': 'Bezig…',
  'common.advanced': 'Geavanceerd',
  'onBehalf.close': 'Downloadbevestiging sluiten',
  'onBehalf.title': 'Downloaden als {name}?',
  'onBehalf.help':
    'Deze download gebruikt de uitvoervoorkeuren en bestemmingsinstellingen van {name}.',
  'onBehalf.itemTitle': 'Titel',
  'onBehalf.queuing': 'In wachtrij plaatsen…',
  'onBehalf.confirm': 'Bevestigen',
  'config.close': 'Instellingenvenster sluiten',
  'config.dialog': 'Informatie over instellingen',
  'config.required': 'Configuratievolume vereist',
  'config.newFeature': 'Nieuwe functie: instellingenpagina',
  'config.requiredHelp':
    'Voeg een configuratievolume toe aan je Docker Compose-bestand om instellingen op te slaan:',
  'config.featureHelp':
    'BookFlow heeft nu een instellingenpagina. Voeg een configuratievolume toe aan je Docker Compose-bestand om die in te schakelen:',
  'config.requiredNote':
    'Zonder dit volume blijven instellingenwijzigingen niet behouden na een containerherstart.',
  'config.featureNote':
    'Hiermee kun je instellingen via de interface aanpassen en behouden na containerherstarts.',
  'config.continue': 'Naar instellingen',
  'config.gotIt': 'Begrepen',
  'release.close': 'Releasevenster sluiten',
  'release.noCover': 'Geen omslag beschikbaar',
  'release.manualSearch': 'Handmatige zoekopdracht',
  'release.sort': 'Releases sorteren',
  'release.filter': 'Releases filteren',
  'release.format': 'Formaat',
  'release.language': 'Taal',
  'release.indexers': 'Indexers',
  'release.allFormats': 'Alle formaten',
  'release.allIndexers': 'Alle indexers',
  'release.customQuery': 'Typ een eigen zoekopdracht (overschrijft alle bronnen)',
  'release.bestMatch': 'Beste overeenkomst (standaard)',
  'release.noCoverText': 'Geen omslag',
  'release.errorLoading': 'Fout bij laden van releases',
  'release.failed': 'Mislukt',
  'release.removeSelected': 'Geselecteerde {label} verwijderen',
  'release.retry': 'Opnieuw proberen',
  'release.downloaded': 'Gedownload',
  'release.downloading': 'Downloaden',
  'release.locating': 'Bestanden zoeken',
  'release.resolving': 'Verwerken',
  'release.queued': 'In wachtrij',
  'release.download': 'Downloaden',
  'release.onDisk': 'Op schijf',
  'release.findReleases': 'Releases zoeken',
  'release.manualQuery': 'Handmatige zoekopdracht',
  'release.untitled': 'Zonder titel',
  'release.bookCover': 'Boekomslag',
  'release.readerCount': '{count} lezers',
  'release.pageCount': '{count} pagina’s',
  'release.seriesPosition': '#{position} in {series}',
  'release.seriesPositionOf': '#{position} van {count} in {series}',
  'release.partOfSeries': 'Onderdeel van {series}',
  'release.viewSeries': 'Serie bekijken',
  'release.showLess': 'Minder tonen',
  'release.more': 'meer',
  'release.viewOn': 'Bekijken op {provider}',
  'release.apply': 'Toepassen',
  'release.manualQueryHelp':
    'Een handmatige zoekopdracht overschrijft uitbreiding op ISBN, titel, auteur en taal.',
  'activity.noCover': 'Geen omslag',
  'activity.unknownTitle': 'Onbekende titel',
  'activity.rejectRequest': 'Aanvraag voor {title} afwijzen',
  'activity.optionalNote': 'Optionele toelichting voor de gebruiker',
  'activity.rejecting': 'Afwijzen…',
  'activity.reject': 'Afwijzen',
  'activity.removeFromQueue': 'Uit wachtrij verwijderen',
  'activity.stopDownload': 'Download stoppen',
  'activity.clear': 'Wissen',
  'activity.approve': 'Goedkeuren',
  'activity.cancelRequest': 'Aanvraag annuleren',
  'activity.action': 'Actie',
  'activity.anySource': 'Elke bron',
  'activity.requested': 'Aangevraagd',
  'activity.type': 'Type',
  'activity.source': 'Bron',
  'activity.attachedFile': 'Bijgevoegd bestand',
  'activity.fieldTitle': 'Titel',
  'activity.size': 'Grootte',
  'activity.format': 'Formaat',
  'activity.working': 'Bezig…',
  'activity.manuallyApprove': 'Handmatig als goedgekeurd markeren',
  'activity.browseAlternatives': 'Alternatieven bekijken',
  'activity.unknown': 'Onbekend',
  'activity.approveAttachedFile': 'Bijgevoegd bestand goedkeuren',
  'activity.browseReleasesToRetry': 'Releases bekijken om opnieuw te proberen',
  'activity.browseReleasesToApprove': 'Releases bekijken om goed te keuren',
  'activity.book': 'Boek',
  'activity.noAttachedRelease':
    'Er zijn geen gegevens van een bijgevoegde release. Kies een release voor je goedkeurt.',
  'activity.previousDownloadFailed':
    'De vorige download is mislukt. Kies een release voordat je opnieuw goedkeurt.',
  'activity.bookRequestWithoutFile':
    'Dit is een boekaanvraag zonder bijgevoegd bestand. Kies een release voor je goedkeurt.',
  'activity.clearedReleaseAfterFailure':
    'De vorige download is mislukt en de bijgevoegde release is verwijderd. Kies een release voordat je opnieuw goedkeurt.',
  'activity.hideDetails': 'Details verbergen',
  'activity.showDetails': 'Details tonen',
  'activity.requesterCount': '{count} aanvrager(s)',
  'activity.hide': 'verbergen',
  'activity.show': 'tonen',
  'activity.userFallback': 'Gebruiker {id}',
  'activity.selected': 'Geselecteerd',
  'activity.findRelease': 'Release zoeken',
  'activity.markAvailable': 'Als beschikbaar markeren',
  'activity.rejectSelected': 'Geselecteerde afwijzen',
  'onboarding.title': 'Installatie',
  'onboarding.dialog': 'Installatiewizard',
  'onboarding.close': 'Installatiewizard sluiten',
  'onboarding.loading': 'Installatiewizard laden…',
  'onboarding.loadFailed': 'Installatiewizard kon niet worden geladen',
  'onboarding.skipped': 'Installatie overgeslagen — standaardwaarden worden gebruikt',
  'onboarding.skipFailed': 'Installatie kon niet worden overgeslagen',
  'onboarding.complete': 'Installatie voltooid!',
  'onboarding.saveFailed': 'Instellingen konden niet worden opgeslagen',
  'onboarding.noCurrentStep': 'Geen huidige stap',
  'onboarding.actionFailed': 'Actie mislukt',
  'onboarding.unsupportedField': 'Niet-ondersteund onboardingveld: {type}',
  'onboarding.unknownField': 'Onbekend veldtype',
  'onboarding.step': 'Stap {current} van {total}',
  'onboarding.skip': 'Installatie overslaan',
  'onboarding.back': 'Terug',
  'onboarding.finish': 'Installatie voltooien',
  'onboarding.next': 'Volgende',
  'settings.close': 'Instellingen sluiten',
  'settings.restartRequired':
    'Sommige instellingen vereisen een containerherstart om actief te worden',
  'settings.noTabSelected': 'Geen tabblad geselecteerd',
  'settings.openingUsers': 'Gebruikers openen…',
  'settings.securityLoadFailed': 'Beveiligingsinstellingen konden niet worden geladen',
  'settings.selectCategory': 'Selecteer een categorie om te configureren',
};

export const translations: Record<UiLanguage, Record<TranslationKey, string>> = { en, nl };
export type { TranslationKey };
